// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 512 512%27%3E%3Cpath fill=%27%236b7280%27 d=%27M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 512 512%27%3E%3Cpath fill=%27%236b7280%27 d=%27M278.6 105.4c-12.5-12.5-32.8-12.5-45.3 0l-192 192c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L256 173.3l169.4 169.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-192-192z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 512 512%27%3E%3Cpath fill=%27%236b7280%27 d=%27M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 512 512%27%3E%3Cpath transform=%27rotate%28180 256 256%29%27 fill=%27%236b7280%27 d=%27M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
}

.modal {
    background: var(--bg-primary);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 12px;
    width: min(90vw, 520px);
    max-height: 85vh;
    padding: 18px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
}

.modal-header h3 {
    margin: 0;
    font-size: 1.1rem;
    color: var(--text-primary);
}

.modal-close {
    background: transparent;
    border: none;
    color: var(--text-primary);
    font-size: 1.35rem;
    cursor: pointer;
}

.modal-body {
    overflow-y: auto;
    max-height: 50vh;
    padding-right: 8px;
    color: var(--text-primary);
}

.standards-list {
    display: grid;
    gap: 10px;
    margin-top: 12px;
}

.standards-item {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 10px 12px;
    border-radius: 8px;
    background: var(--bg-secondary);
    border: 1px solid rgba(255,255,255,0.08);
    cursor: pointer;
}

.standards-item input {
    cursor: pointer;
}

.empty-standards {
    padding: 14px;
    border-radius: 8px;
    background: rgba(255,255,255,0.05);
    color: var(--text-secondary);
}

.modal-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    justify-content: flex-end;
}

.pending-load-item {
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: var(--bg-secondary);
    border-radius: 10px;
    padding: 14px 16px;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.pending-load-item + .pending-load-item {
    margin-top: 8px;
}

.pending-load-note {
    color: var(--text-secondary);
    font-size: 0.88rem;
    line-height: 1.4;
    margin-bottom: 10px;
}

.pending-load-item-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 0.5rem;
    min-width: 0;
}

.pending-load-item-number {
    font-size: 0.85rem;
    color: var(--text-secondary);
    font-weight: 600;
    flex-shrink: 0;
}

.pending-load-source {
    color: var(--text-secondary);
    font-size: 0.8rem;
    font-style: italic;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-width: 0;
}

.pending-load-name-row {
    display: grid;
    grid-template-columns: 1fr 90px;
    gap: 0.75rem;
}

.pending-load-field {
    display: flex;
    flex-direction: column;
    gap: 0.3rem;
}

.pending-load-field > span {
    color: var(--text-secondary);
    font-size: 0.8rem;
    font-weight: 500;
}

.pending-load-field input,
.pending-load-field select {
    box-sizing: border-box;
    width: 100%;
    height: 2.5rem;
    padding: 0 0.75rem;
    border: 1px solid var(--gray-900);
    border-radius: 6px;
    font-size: 0.9rem;
    color: var(--gray-900);
    background: var(--bg-primary);
    transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.pending-load-field input:hover,
.pending-load-field select:hover {
    border-color: var(--gray-400);
}

.pending-load-field input:focus,
.pending-load-field select:focus {
    outline: none;
    border-color: var(--primary);
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}

.club-autocomplete {
    position: relative;
}

.club-autocomplete-list {
    position: absolute;
    top: calc(100% + 4px);
    left: 0;
    right: 0;
    z-index: 20;
    margin: 0;
    padding: 0.25rem;
    list-style: none;
    background: var(--bg-primary);
    border: 1px solid var(--gray-200);
    border-radius: 6px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
    max-height: 220px;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
}

.club-autocomplete-option {
    display: block;
    width: 100%;
    padding: 0.5rem 0.6rem;
    border: none;
    border-radius: 4px;
    background: transparent;
    color: var(--text-primary);
    font-size: 0.85rem;
    text-align: left;
    cursor: pointer;
}

.club-autocomplete-option:hover {
    background: var(--gray-50);
}

.action-buttons {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 0.25rem;
    padding: 5px 0;
}

.btn-save-prominent {
    display: inline-flex;
    align-items: center;
    gap: 0.45rem;
    background: var(--success);
    color: white;
    border: none;
    padding: 0.5rem 0.9rem;
    border-radius: 6px;
    font-weight: 600;
    font-size: calc(var(--h1) * 0.7);
    cursor: pointer;
    margin-right: auto;
}

.btn-save-prominent:hover:not(:disabled) {
    background: #047857;
}

.btn-save-prominent.is-saved {
    background: transparent;
    color: var(--success);
}

.btn-save-prominent:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.comparison-action-bar {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 100;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.875rem 1.25rem;
    background: var(--bg-primary);
    opacity: 0.9;
    border-top: 2px solid var(--primary);
    box-shadow: 0 -4px 24px rgba(0, 0, 0, 0.2);
    gap: 1rem;
    animation: slideUpBar 0.22s ease-out;
}

@keyframes slideUpBar {
    from { transform: translateY(100%); opacity: 0; }
    to   { transform: translateY(0);    opacity: 1; }
}

.comparison-action-count {
    font-size: 0.875rem;
    color: var(--text-secondary);
}

.comparison-action-buttons {
    display: flex;
    gap: 0.5rem;
}

.saved-section.has-action-bar {
    padding-bottom: 5rem;
}

#searchResults {
    display: grid;
    gap: 0.75rem;
    min-width: 0;
    overflow: hidden;
}

.swimmer-result {
    position: relative;
    background: linear-gradient(145deg, color-mix(in srgb, var(--primary) 7%, var(--bg-primary)) 0%, var(--bg-primary) 70%);
    border: 1px solid color-mix(in srgb, var(--primary) 20%, var(--gray-200));
    border-radius: 10px;
    padding: 0.45rem 0.65rem 0.45rem 1rem;
    box-shadow: 0 2px 8px rgba(16, 24, 40, 0.05);
    overflow: hidden;
    transition: transform 0.25s ease, border-color 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;
}

.swimmer-result::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: 3px;
    background: linear-gradient(to bottom, var(--primary), color-mix(in srgb, var(--primary) 55%, white));
}

.swimmer-result:hover {
    border-color: var(--primary);
    box-shadow: 0 4px 14px rgba(16, 24, 40, 0.09);
}

.swimmer-result-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.25rem;
}

.swimmer-result-header h3 {
    margin: 0;
    font-size: calc(var(--h1) * 0.8);
    color: var(--gray-900);
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 0;
}

.swimmer-result-card-actions {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    gap: 0;
}

.swimmer-result-card-actions .btn-ghost {
    padding: 0.2rem 0.3rem;
    font-size: calc(var(--h1) * 0.7);
    opacity: 0.6;
    transition: opacity 0.1s;
}

.swimmer-result:hover .swimmer-result-card-actions .btn-ghost,
.swimmer-result-card-actions .btn-ghost:hover {
    opacity: 1;
}

.swimmer-result-card-actions .swimmer-result-save {
    color: var(--success);
}

.swimmer-result-card-actions .swimmer-result-save:disabled:not(.is-saved) {
    opacity: 0.6;
    cursor: not-allowed;
}

.swimmer-result-card-actions .swimmer-result-save.is-saved {
    opacity: 1;
    cursor: default;
}

.swimmer-result-meta {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.35rem;
    margin-top: 0.2rem;
}

.swimmer-result-meta-text {
    font-size: calc(var(--h1) * 0.65);
    color: var(--gray-500);
}

.pagination-info {
    color: var(--gray-600);
    font-size: calc(var(--h1) * 0.7);
    margin-bottom: 1rem;
    text-align: center;
}

.pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    margin-top: 1.5rem;
    padding: 1rem 0;
}

.pagination button {
    padding: 0.5rem 1rem;
    font-size: calc(var(--h1) * 0.7);
    min-width: 100px;
}

.pagination span {
    color: var(--gray-700);
    font-weight: 500;
}

.swimmer-info {
    background: var(--gray-50);
    padding: 1rem;
    border-radius: 6px;
    margin-bottom: 1.5rem;
    border: 1px solid var(--gray-200);
    display: grid;
    gap: 0.5rem;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
}

.swimmer-info p {
    margin: 0;
    padding: 0.1rem 0;
    color: var(--gray-900);
    font-size: calc(var(--h1) * 0.75);
    display: flex;
    align-items: center;
    gap: 0.5rem;
    border-bottom: 1px solid transparent;
}

.swimmer-info strong {
    color: var(--primary);
    font-weight: 600;
    min-width: 120px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    gap: 0.4rem;
}

.swimmer-info .info-select {
    font-size: inherit;
    padding: 0 0.3rem;
    border: 1px solid var(--border);
    border-radius: 4px;
    background: var(--bg-primary);
    color: var(--text-primary);
    flex: 1;
    min-width: 0;
    max-width: 160px;
    height: calc(var(--h1) * 0.75 * 1.5);
    box-sizing: border-box;
    line-height: normal;
    appearance: none;
}

.swimmer-info .info-edit-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: none;
    background: transparent;
    color: var(--primary);
    padding: 0.25rem 0.5rem;
    margin-left: 0.25rem;
    border-radius: 4px;
    cursor: pointer;
    opacity: 0.8;
    transition: all 0.15s ease;
    font-size: calc(var(--h1) * 0.75);
}

.swimmer-info .info-edit-button:hover,
.swimmer-info .info-edit-button:focus-visible {
    background: rgba(59, 130, 246, 0.08);
}

.swimmer-info .info-text {
    color: var(--gray-900);
    font-size: inherit;
    line-height: 1.4;
    flex: 1;
    min-width: 0;
}

.swimmer-info .info-row {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    flex-wrap: wrap;
}

.tabs {
    display: flex;
    gap: 0;
    margin-bottom: 1.5rem;
    border-bottom: 1px solid var(--gray-200);
}

.tab-btn {
    padding: 0.75rem 1.5rem;
    background: transparent;
    color: var(--gray-600);
    border: none;
    border-bottom: 2px solid transparent;
    cursor: pointer;
    font-weight: 500;
    font-size: calc(var(--h1) * 0.75);
    transition: all 0.15s;
}

.tab-btn:hover {
    color: var(--gray-900);
    background: var(--gray-50);
}

.tab-btn.active {
    color: var(--primary);
    border-bottom-color: var(--primary);
}

.tab-content {
    display: none;
}

.tab-content.active {
    display: block;
}

.filter-section {
    display: flex;
    gap: 1rem;
    margin-bottom: 1.5rem;
    flex-wrap: wrap;
    align-items: end;
}

.filter-section > div {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
}

.filter-section label {
    font-size: calc(var(--h1) * 0.7);
    font-weight: 500;
    color: var(--gray-700);
}

.filter-section select {
    min-width: 150px;
}

.filter-section input[type="text"] {
    min-width: 200px;
}

.search-controls {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    margin-bottom: 1.25rem;
}

.search-controls > button {
    flex-shrink: 0;
}

.search-input-wrap {
    position: relative;
    flex: 1;
    min-width: 0;
}

.search-input-wrap input {
    width: 100%;
    padding-inline-end: 2rem !important;
}

.search-filter-row {
    width: 100%;
}

.search-filter-input-wrap {
    position: relative;
    min-width: 200px;
}

.search-filter-icon {
    position: absolute;
    top: 50%;
    left: 0.875rem;
    transform: translateY(-50%);
    width: 1rem;
    font-size: 0.9rem;
    color: var(--gray-500);
    pointer-events: none;
}

.search-filter-input {
    width: 100%;
    min-width: 100%;
    padding-left: 2.5rem !important;
    padding-inline-start: 2.5rem !important;
    padding-inline-end: 2rem !important;
}

.rankings-county-filter {
    position: relative;
    min-width: 200px;
}

.rankings-county-icon {
    position: absolute;
    top: 50%;
    left: 0.875rem;
    transform: translateY(-50%);
    width: 1rem;
    font-size: 0.9rem;
    color: var(--gray-500);
    pointer-events: none;
}

.rankings-county-select {
    min-width: 100%;
    -webkit-appearance: none;
    appearance: none;
    width: 100%;
    padding-left: 2.5rem;
    padding-inline-start: 2.5rem;
    padding-right: 2.5rem;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: right 0.75rem center;
    background-size: 0.75rem;
}

.rankings-county-select:focus {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.age-multiselect-trigger {
    width: 100%;
    text-align: left;
    padding: 0.625rem 2.5rem;
    padding-inline-start: 2.5rem;
    padding-inline-end: 2.5rem;
    border: 1px solid var(--gray-300);
    border-radius: 6px;
    font-size: calc(var(--h1) * 0.75);
    cursor: pointer;
    background-color: var(--bg-primary);
    color: var(--gray-900);
    transition: all 0.15s ease;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-repeat: no-repeat;
    background-position: right 0.75rem center;
    background-size: 0.75rem;
}

.age-multiselect-trigger:hover:not(:disabled) {
    border-color: var(--gray-400);
    background-color: transparent;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-repeat: no-repeat;
    background-position: right 0.75rem center;
    background-size: 0.75rem;
}

.age-multiselect-trigger:focus {
    outline: none;
    border-color: var(--primary);
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}

.age-multiselect-trigger:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.age-multiselect-trigger[aria-expanded="true"] {
    border-color: var(--gray-400);
    background-color: transparent;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    background-repeat: no-repeat;
    background-position: right 0.75rem center;
    background-size: 0.75rem;
}

.age-multiselect-label {
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.age-multiselect-popover {
    position: absolute;
    top: calc(100% + 4px);
    left: 0;
    right: 0;
    z-index: 50;
    background: var(--bg-primary);
    border: 1px solid var(--gray-300);
    border-radius: 6px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
    padding: 0.35rem;
    max-height: 280px;
    overflow-y: auto;
}

.age-multiselect-popover-anchored {
    left: auto;
    right: 0;
    width: max-content;
    min-width: 10rem;
}

.age-multiselect-option {
    display: flex;
    align-items: center;
    gap: 0.55rem;
    width: 100%;
    padding: 0.5rem 0.6rem;
    border: none;
    background: transparent;
    color: var(--gray-900);
    font-size: calc(var(--h1) * 0.75);
    cursor: pointer;
    border-radius: 4px;
    text-align: left;
}

.age-multiselect-option:hover {
    background: var(--bg-secondary);
}

.age-multiselect-check {
    width: 1rem;
    height: 1rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: 1.5px solid var(--gray-400);
    border-radius: 3px;
    flex-shrink: 0;
    font-size: 0.6rem;
    color: #fff;
}

.age-multiselect-option.selected .age-multiselect-check {
    background: var(--primary);
    border-color: var(--primary);
}

.age-multiselect-option.is-fixed {
    cursor: default;
    opacity: 0.65;
}

.age-multiselect-option.is-fixed:hover {
    background: none;
}

.age-multiselect-locked {
    margin-left: auto;
    font-size: 0.68rem;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    color: var(--gray-400);
}

.filter-chip-label {
    font-size: 0.65rem;
    font-weight: 700;
    letter-spacing: 0.06em;
    color: var(--gray-400);
    text-transform: uppercase;
    white-space: nowrap;
    flex-shrink: 0;
}

.filter-section .filter-chip-group {
    flex-direction: row;
    align-items: center;
    gap: 0.35rem;
}

.filter-section .rankings-age-controls {
    flex-direction: row;
    align-items: center;
    gap: 0.5rem;
}

.mobile-supplement {
    display: none;
}

.card-event-header {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    gap: 0.5rem;
    white-space: nowrap;
}

.card-inline-time {
    font-weight: 600;
    white-space: nowrap;
    flex-shrink: 0;
}

.card-meta-row {
    font-size: 0.72rem;
    color: var(--gray-400);
    margin-top: 0.15rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.rank-card-sub {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 0.5rem;
    margin-top: 0.1rem;
    font-size: 0.72rem;
    color: var(--gray-400);
}

.rank-card-course {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.rank-card-sub-right {
    display: flex;
    align-items: baseline;
    gap: 0.4rem;
    flex-shrink: 0;
    white-space: nowrap;
}

.rank-card-fina {
    font-weight: 600;
    color: var(--gray-500);
}

.rank-card-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.35rem 0.7rem;
    margin-top: 0.6rem;
}

.rank-cell {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.4rem;
    min-width: 0;
}

.rank-cell-label {
    font-size: 0.65rem;
    color: var(--gray-500);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.rank-cell-value {
    display: inline-flex;
    align-items: center;
    gap: 0.25rem;
    flex-shrink: 0;
}

.rank-cell-link {
    color: var(--gray-400);
    font-size: 0.6rem;
    padding: 0.25rem;
    line-height: 1;
}

.rank-cell-link:hover {
    color: var(--primary);
}

.stroke-link {
    color: var(--gray-400);
    font-size: 0.6rem;
    padding: 0.25rem;
    line-height: 1;
}

.stroke-link:hover {
    color: var(--primary);
}

.course-pill {
    display: inline-flex;
    align-items: center;
    gap: 0.3rem;
    min-width: 2.1rem;
    justify-content: center;
    padding: 0.15rem 0.45rem;
    border: 1px solid transparent;
    border-radius: 999px;
    background: var(--gray-100);
    color: var(--gray-600);
    font-size: 0.75rem;
    font-weight: 700;
    font-family: inherit;
    line-height: 1.5;
    cursor: default;
    transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.rank-pill {
    display: inline-flex;
    align-items: center;
    gap: 0.3rem;
    min-width: 2.9rem;
    justify-content: center;
    padding: 0.15rem 0.45rem;
    border: 1px solid transparent;
    border-radius: 999px;
    background: var(--gray-100);
    color: var(--gray-700);
    font-size: 0.75rem;
    font-weight: 700;
    font-family: inherit;
    line-height: 1.5;
    cursor: pointer;
    transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.rank-pill:disabled {
    cursor: default;
}

.rank-pill:hover {
    background-color: var(--gray-200);
}

.rank-pill-total {
    font-weight: 500;
    opacity: 0.75;
}

.rank-pill.is-strong {
    background: color-mix(in srgb, var(--rank-strong) 20%, var(--bg-primary));
    border-color: color-mix(in srgb, var(--rank-strong) 42%, var(--bg-primary));
    color: color-mix(in srgb, var(--rank-strong) 68%, var(--gray-900));
}

.rank-pill.is-strong:hover {
    background: color-mix(in srgb, var(--rank-strong) 30%, var(--bg-primary));
}

.rank-pill.is-empty {
    background: transparent;
    border-color: var(--gray-300);
    border-style: dashed;
    color: var(--gray-400);
    font-weight: 500;
}

.rank-pill.is-unranked,
.rank-pill.is-loading {
    background: transparent;
    color: var(--gray-400);
    font-weight: 500;
}

@media (max-width: 330px) {
    .rank-card-grid {
        grid-template-columns: minmax(0, 1fr);
    }
}

.filter-toggles {
    display: flex;
    gap: 0.35rem;
    flex-wrap: wrap;
}

.filter-collapse-toggle {
    display: none;
}

.filter-toggle {
    padding: 0.25rem 0.55rem;
    border: 1px solid var(--gray-300);
    border-radius: 6px;
    background: var(--bg-primary);
    color: var(--gray-700);
    font-size: 0.8rem;
    cursor: pointer;
    transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.filter-toggle:hover {
    border-color: var(--primary);
    color: var(--primary);
}

.filter-toggle.active {
    background: var(--primary);
    border-color: var(--primary);
    color: white;
}

.filter-toggle-unavailable.active {
    border-style: dashed;
    border-color: color-mix(in srgb, white 55%, var(--primary));
    text-decoration: line-through;
    text-decoration-thickness: 1px;
}

.filter-toggle-unavailable.active:hover {
    border-color: white;
    color: white;
}

.segmented-toggle {
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    flex-wrap: wrap;
}

.segmented-toggle > button,
.segmented-toggle .age-group-affordance {
    padding: 0.3rem 0.85rem;
    min-width: 3rem;
    border: 1px solid var(--gray-300);
    border-radius: 999px;
    background: var(--bg-primary);
    color: var(--gray-700);
    font-size: 0.875rem;
    font-weight: 500;
    cursor: pointer;
    transition: background 0.18s ease, color 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease;
    white-space: nowrap;
}

.segmented-toggle > button:hover:not(.active):not(:disabled),
.segmented-toggle .age-group-affordance:hover:not(:disabled) {
    border-color: var(--primary);
    color: var(--primary);
}

.segmented-toggle > button.active {
    background: var(--primary);
    border-color: var(--primary);
    color: white;
    box-shadow: 0 1px 4px rgba(37, 99, 235, 0.3);
}

.segmented-toggle > button:disabled,
.segmented-toggle .age-group-affordance:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.age-group-inline {
    position: relative;
    display: inline-flex;
}

.segmented-toggle .age-group-affordance {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.35rem;
    border-style: dashed;
    color: var(--gray-500);
}

.segmented-toggle .age-group-affordance:hover:not(:disabled),
.segmented-toggle .age-group-affordance[aria-expanded="true"] {
    border-style: solid;
    border-color: var(--primary);
    color: var(--primary);
}

.comparison-controls {
    display: flex;
    gap: 0.75rem;
    margin-bottom: 1.5rem;
}

select {
    padding: 0.625rem 0.875rem;
    border: 1px solid var(--gray-300);
    border-radius: 6px;
    font-size: calc(var(--h1) * 0.75);
    cursor: pointer;
    background: var(--bg-primary);
    color: var(--gray-900);
    transition: all 0.15s ease;
}

select:hover {
    border-color: var(--gray-400);
}

select:focus {
    outline: none;
    border-color: var(--primary);
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}

.table-container {
    overflow-x: auto;
    border-radius: 6px;
    border: 1px solid var(--gray-200);
}

.splits-panel table {
    font-size: calc(var(--h1) * 0.6);
}

table {
    width: 100%;
    border-collapse: collapse;
    font-size: calc(var(--h1) * 0.75);
}

table th {
    background: var(--gray-50);
    color: var(--gray-700);
    padding: 0.75rem 1rem;
    text-align: left;
    font-weight: 600;
    font-size: calc(var(--h1) * 0.7);
    border-bottom: 1px solid var(--gray-200);
}

table td {
    padding: 0.75rem 1rem;
    border-bottom: 1px solid var(--gray-200);
    color: var(--gray-900);
}

table tbody tr:hover {
    background: var(--gray-50);
}

table tbody tr:last-child td {
    border-bottom: none;
}

.faster {
    color: var(--success);
    font-weight: 600;
}

.slower {
    color: var(--danger);
    font-weight: 600;
}

.section-toggle {
    color: var(--gray-400);
    padding: 0.375rem;
    line-height: 1;
    flex-shrink: 0;
    -webkit-tap-highlight-color: transparent;
}

.section-toggle:hover:not(:disabled) {
    color: var(--primary);
}

.section-toggle:hover:not(:disabled),
.section-toggle:active:not(:disabled) {
    background: transparent !important;
    filter: none;
    transform: none;
}

.chevron-icon {
    transition: transform 0.2s ease;
}

.chevron-icon.expanded {
    transform: rotate(180deg);
}

#savedSwimmers {
    display: grid;
    gap: 0.75rem;
}

.saved-swimmer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
    padding: 1rem;
    background: var(--bg-primary);
    border-radius: 6px;
    border: 1px solid var(--gray-200);
    transition: all 0.15s ease;
}

.saved-swimmer:hover {
    border-color: var(--primary);
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

.saved-swimmer-info h4 {
    color: var(--gray-900);
    margin-bottom: 0.25rem;
    font-size: calc(var(--h1) * 0.8);
    font-weight: 600;
}

.saved-swimmer-info p {
    color: var(--gray-600);
    font-size: calc(var(--h1) * 0.65);
}

.club-group {
    border: 1px solid var(--gray-200);
    border-radius: 8px;
    overflow: hidden;
    max-width: 100%;
}

.club-group:hover {
    border-color: var(--gray-400);
    opacity: 1;
}

.club-group-spaced {
    margin-top: 0.75rem;
}

.club-group .table-container {
    border: none;
    border-radius: 0;
    overflow-x: auto;
}

.club-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.5rem 0.75rem;
    margin-bottom: 0;
    background: var(--gray-100);
    border-left: 3px solid var(--primary);
    cursor: pointer;
    user-select: none;
    gap: 0.5rem;
    transition: background 0.15s;
}

.club-header:hover {
    background: var(--gray-200);
}

.club-header-title {
    margin: 0;
    font-size: calc(var(--h1) * 0.75);
    font-weight: 600;
    color: var(--gray-800);
    flex: 1;
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.club-count {
    font-weight: 400;
    color: var(--gray-500);
}

.saved-swimmers-list {
    display: flex;
    flex-direction: column;
    gap: 0;
    padding: 0.25rem 0;
}

.saved-swimmer-row {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.3rem 0.5rem 0.3rem 0.75rem;
    border-bottom: 1px solid var(--gray-100);
    border-left: 3px solid transparent;
    cursor: pointer;
    transition: background 0.1s, border-left-color 0.1s;
}

.saved-swimmer-row:last-child {
    border-bottom: none;
}

.saved-swimmer-row:hover {
    background: var(--gray-50);
}

.saved-swimmer-row.selected {
    background: rgba(37, 99, 235, 0.06);
    border-left-color: var(--primary);
}

.saved-swimmer-row-check {
    width: 1rem;
    color: var(--primary);
    font-size: calc(var(--h1) * 0.65);
    flex-shrink: 0;
    text-align: center;
}

.saved-swimmer-row-info {
    flex: 1;
    min-width: 0;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    overflow:hidden;
}

.saved-swimmer-row-name {
    font-size: calc(var(--h1) * 0.8);
    font-weight: 600;
    color: var(--gray-900);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex-shrink: 1;
    min-width: 0;
}

.saved-swimmer-row-meta {
    font-size: calc(var(--h1) * 0.7);
    color: var(--gray-500);
    flex-shrink: 0;
}

.saved-swimmer-row .swimmer-tags {
    display: flex;
    gap: 0.25rem;
    flex-shrink: 0;
    overflow: hidden;
    max-width: 40%;
    margin: 0;
}

.saved-swimmer-row .swimmer-tags .swimmer-tag-badge {
    font-size: calc(var(--h1) * 0.6);
    padding: 0.1rem 0.35rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipses;
    max-width: 8rem;
}

.saved-swimmer-row-tag-input {
    flex: 1;
    min-width: 0;
}

.saved-swimmer-row-tag-input .group-input {
    width: 100%;
}

.saved-swimmer-row-actions {
    display: flex;
    align-items: center;
    gap: 0.25rem;
    flex-shrink: 0;
}

.saved-swimmer-row-actions button {
    padding: 0.2rem 0.5rem;
    font-size: calc(var(--h1) * 0.65);
}

.search-results-content {
    min-width: 0;
    overflow: hidden;
}

.search-results-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
    gap: 0.5rem;
}

.search-carousel {
    position: relative;
    display: grid;
    grid-template-columns: auto 1fr auto;
    align-items: center;
    gap: 0.35rem;
    padding: 1.15rem 0.4rem 1.7rem;
    border: 1px solid color-mix(in srgb, var(--primary) 20%, var(--gray-200));
    border-radius: 12px;
    background:
        linear-gradient(145deg, color-mix(in srgb, var(--primary) 7%, var(--bg-primary)) 0%, var(--bg-primary) 70%),
        var(--bg-primary);
    box-shadow: 0 6px 20px rgba(16, 24, 40, 0.06);
    overflow: hidden;
}

.search-carousel-viewport {
    overflow: hidden;
    min-width: 0;
}

.search-carousel-track {
    display: flex;
    transition: transform 0.4s ease;
}

.search-carousel-slide {
    flex: 0 0 100%;
    min-width: 0;
    display: grid;
    justify-items: center;
    text-align: center;
    gap: 0.45rem;
    padding: 0 0.75rem;
}

.search-carousel-icon {
    width: 2.3rem;
    height: 2.3rem;
    border-radius: 999px;
    display: grid;
    place-items: center;
    background: color-mix(in srgb, var(--primary) 14%, var(--bg-primary));
    color: var(--primary);
    font-size: 0.95rem;
}

.search-carousel-slide h3 {
    margin: 0;
    font-size: calc(var(--h1) * 0.82);
    line-height: 1.2;
    letter-spacing: 0.01em;
    color: var(--gray-900);
}

.search-carousel-slide p {
    margin: 0;
    font-size: calc(var(--h1) * 0.72);
    color: var(--gray-600);
    max-width: 34ch;
}

.search-carousel-examples {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 0.4rem;
    margin-top: 0.1rem;
}

.search-carousel-example-chip {
    padding: 0.3rem 0.8rem;
    border: 1px solid color-mix(in srgb, var(--primary) 30%, var(--gray-300));
    border-radius: 999px;
    background: var(--bg-primary);
    color: var(--primary);
    font-size: calc(var(--h1) * 0.68);
    font-weight: 600;
    cursor: pointer;
    transition: background 0.15s ease, color 0.15s ease, transform 0.1s ease;
}

.search-carousel-example-chip:hover {
    background: var(--primary);
    color: #fff;
    transform: translateY(-1px);
}

.search-carousel-nav {
    flex-shrink: 0;
    width: 2rem;
    height: 2rem;
    padding: 0;
    margin: 0;
    border-radius: 999px;
    border: 1px solid color-mix(in srgb, var(--primary) 25%, var(--gray-300));
    background: var(--bg-primary);
    color: var(--primary);
    font-size: 0.7rem;
    line-height: 1;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease, transform 0.1s ease;
    z-index: 1;
}

.search-carousel-nav:hover {
    background: var(--primary);
    border-color: var(--primary);
    color: #fff;
}

.search-carousel-nav:active {
    transform: scale(0.92);
}

.search-carousel-dots {
    position: absolute;
    bottom: 0.6rem;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    gap: 0.35rem;
}

.search-carousel-dot {
    width: 0.4rem;
    height: 0.4rem;
    border-radius: 999px;
    border: none;
    padding: 0;
    background: color-mix(in srgb, var(--primary) 25%, var(--gray-300));
    cursor: pointer;
    transition: background 0.15s ease, transform 0.15s ease;
}

.search-carousel-dot.active {
    background: var(--primary);
    transform: scale(1.3);
}

.swimmer-result-compact {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.35rem 0.5rem;
    border-bottom: 1px solid var(--gray-100);
    transition: background 0.1s;
    min-width: 0;
    overflow: hidden;
}

.swimmer-result-compact:last-child {
    border-bottom: none;
}

.swimmer-result-compact:hover {
    background: var(--gray-50);
}

.swimmer-result-compact-name {
    font-size: calc(var(--h1) * 0.8);
    font-weight: 600;
    color: var(--gray-900);
    flex-shrink: 0;
}

.swimmer-result-compact-meta {
    font-size: calc(var(--h1) * 0.7);
    color: var(--gray-500);
    flex: 1;
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.swimmer-result-compact button {
    padding: 0.2rem 0.5rem;
    font-size: calc(var(--h1) * 0.65);
    flex-shrink: 0;
}

.swimmer-result-compact .swimmer-result-save {
    background: var(--success);
    color: white;
    padding: 0.25rem 0.5rem;
}

.swimmer-result-compact .swimmer-result-save.is-saved {
    background: transparent;
    color: var(--success);
    border: 1px solid var(--success);
}

.saved-swimmers-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
    gap: 0.5rem;
    padding: 0.5rem 0.75rem 0.75rem;
}

.saved-swimmer-card {
    position: relative;
    background: linear-gradient(145deg, color-mix(in srgb, var(--primary) 7%, var(--bg-primary)) 0%, var(--bg-primary) 70%);
    border: 1px solid color-mix(in srgb, var(--primary) 20%, var(--gray-200));
    border-radius: 10px;
    padding: 0.45rem 0.65rem 0.45rem 1rem;
    box-shadow: 0 2px 8px rgba(16, 24, 40, 0.05);
    overflow: hidden;
    transition: transform 0.25s ease, border-color 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;
}

.saved-swimmer-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: 3px;
    background: linear-gradient(to bottom, var(--primary), color-mix(in srgb, var(--primary) 55%, white));
}

.saved-swimmer-card:hover {
    border-color: var(--primary);
    box-shadow: 0 4px 14px rgba(16, 24, 40, 0.09);
}

.saved-swimmer-card.selected {
    border-color: var(--primary);
    background: linear-gradient(145deg, color-mix(in srgb, var(--primary) 15%, var(--bg-primary)) 0%, color-mix(in srgb, var(--primary) 5%, var(--bg-primary)) 70%);
}

.saved-swimmer-card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.25rem;
}

.saved-swimmer-card-header .selection-badge {
    position: static;
    width: 18px;
    height: 18px;
    font-size: calc(var(--h1) * 0.55);
    flex-shrink: 0;
}

.saved-swimmer-card-header h3 {
    margin: 0;
    font-size: calc(var(--h1) * 0.8);
    color: var(--gray-900);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 0;
}

.saved-swimmer-card-actions {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    gap: 0;
}

.saved-swimmer-card-actions .btn-ghost {
    padding: 0.2rem 0.3rem;
    font-size: calc(var(--h1) * 0.7);
    opacity: 0.6;
    transition: opacity 0.1s;
}

.saved-swimmer-card:hover .saved-swimmer-card-actions .btn-ghost,
.saved-swimmer-card-actions .btn-ghost:hover {
    opacity: 1;
}

.saved-swimmer-card-meta {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.35rem;
    margin-top: 0.2rem;
}

.saved-swimmer-card-events {
    font-size: calc(var(--h1) * 0.65);
    color: var(--gray-500);
    white-space: nowrap;
}

.saved-swimmer-card-tag-input {
    margin-top: 0.35rem;
}

.swipe-delete-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
}

.swipe-delete-dialog {
    background: var(--bg-primary);
    border-radius: 12px;
    padding: 1.5rem;
    max-width: 300px;
    width: 90%;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.swipe-delete-dialog p {
    margin: 0 0 1.25rem;
    color: var(--gray-900);
    font-size: calc(var(--h1) * 0.85);
    line-height: 1.4;
}

.swipe-delete-dialog-actions {
    display: flex;
    gap: 0.75rem;
    justify-content: flex-end;
}

.selection-badge {
    position: absolute;
    top: 0.5rem;
    right: 0.5rem;
    width: 24px;
    height: 24px;
    background: var(--primary);
    color: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: calc(var(--h1) * 0.7);
    font-weight: bold;
}

.group-filter {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    margin-bottom: 1rem;
    padding: 0.75rem;
    background: var(--gray-50);
    border-radius: 6px;
}

.group-filter label {
    font-size: calc(var(--h1) * 0.7);
    font-weight: 500;
    color: var(--gray-700);
}

.group-filter select {
    flex: 1;
    max-width: 300px;
}

.saved-swimmer-tag-filter {
    position: relative;
    flex: 1;
    max-width: none;
}

.saved-swimmer-tag-icon {
    position: absolute;
    top: 50%;
    left: 0.875rem;
    transform: translateY(-50%);
    width: 1rem;
    font-size: 0.9rem;
    color: var(--gray-500);
    pointer-events: none;
}

.saved-swimmer-tag-select {
    -webkit-appearance: none;
    appearance: none;
    width: 100%;
    padding-left: 2.5rem;
    padding-inline-start: 2.5rem;
    padding-right: 2.5rem;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-repeat: no-repeat;
    background-position: right 0.75rem center;
    background-size: 0.75rem;
}

.saved-swimmer-tag-select:focus {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.group-filter .saved-swimmer-tag-select {
    max-width: none;
}

.saved-swimmer-filter-row .saved-swimmer-search-filter {
    flex: 1;
    width: 100%;
}

.saved-swimmer-filter-row {
    padding: 0;
    background: transparent;
    align-items: stretch;
    gap: 0.5rem;
}

.saved-swimmer-filter-row .saved-swimmer-tag-filter,
.saved-swimmer-filter-row .saved-swimmer-search-filter {
    flex: 1 1 0;
    min-width: 0;
    max-width: none;
}

.swimmer-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 0.375rem;
    margin-bottom: 0.5rem;
}

.swimmer-tag-badge {
    display: inline-flex;
    align-items: center;
    gap: 0.25rem;
    padding: 0.2rem 0.5rem;
    background: var(--primary);
    color: white;
    border-radius: 12px;
    font-size: calc(var(--h1) * 0.6);
    font-weight: 500;
    opacity: 0.8;
}

.swimmer-tag-badge.inactive {
    opacity: 0.45;
}

.swimmer-tag-remove {
    background: none;
    border: none;
    color: white;
    cursor: pointer;
    padding: 0;
    line-height: 1;
    font-size: calc(var(--h1) * 0.52);
    opacity: 0.7;
    display: flex;
    align-items: center;
}

.swimmer-tag-remove:hover {
    opacity: 1;
}

.group-button {
    background-color: var(--primary-light) !important;
    color: var(--text-primary) !important;
    flex: 1;
    padding: 0.5rem 0.75rem;
    font-size: calc(var(--h1) * 0.65);
    background: var(--gray-100);
    border: 1px solid var(--gray-300);
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.15s ease;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.group-button:hover {
    background: var(--gray-200);
    border-color: var(--primary);
}

.group-edit-container {
    flex: 1;
    display: flex;
    min-width: 0;
}

.group-input {
    flex: 1;
    padding: 0.5rem;
    font-size: calc(var(--h1) * 0.65);
    border: 2px solid var(--primary);
    border-radius: 4px;
    min-width: 0;
    width: 0;
    color: var(--gray-900);
}

.group-input:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}

.saved-swimmer-search-filter {
    display: block;
    position: relative;
    width: 100%;
}

.saved-swimmer-search-icon {
    position: absolute;
    top: 50%;
    left: 0.875rem;
    transform: translateY(-50%);
    width: 1rem;
    font-size: 0.9rem;
    color: var(--gray-500);
    pointer-events: none;
}

.saved-swimmer-search-input {
    width: 100%;
    min-width: 100%;
    padding-left: 2.85rem !important;
    padding-right: 2rem !important;
    padding-inline-start: 2.85rem !important;
    padding-inline-end: 2rem !important;
}

.saved-swimmer-search-clear,
.search-filter-clear {
    position: absolute;
    top: 50%;
    right: 0.5rem;
    transform: translateY(-50%);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 1.5rem;
    height: 1.5rem;
    border: none;
    border-radius: 999px;
    background: transparent;
    color: var(--gray-500);
    cursor: pointer;
    transition: color 0.15s ease, background-color 0.15s ease;
}

.saved-swimmer-search-clear:hover,
.search-filter-clear:hover {
    color: var(--gray-700);
    background: var(--gray-100);
}

.saved-swimmer-search-clear:active,
.search-filter-clear:active {
    transform: translateY(-50%) scale(0.98);
}

.comparison-section {
    margin-bottom: 2rem;
}

.swimmer-comparison-names {
    display: flex;
    gap: 1rem;
    margin-bottom: 1.5rem;
    flex-wrap: wrap;
}

.comparison-swimmer-tag {
    flex: 1;
    min-width: 200px;
    padding: 1rem;
    background: var(--gray-50);
    border-radius: 6px;
    border-left: 4px solid var(--primary);
}

.comparison-swimmer-tag strong {
    display: block;
    font-size: calc(var(--h1) * 0.8);
    color: var(--gray-900);
    margin-bottom: 0.25rem;
}

.comparison-swimmer-tag span {
    font-size: calc(var(--h1) * 0.7);
    color: var(--gray-600);
}

.theme-selector {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.5rem 0;
}

.theme-selector label {
    font-size: calc(var(--h1) * 0.7);
    font-weight: 500;
    color: var(--gray-700);
}

.theme-options {
    display: flex;
    gap: 0.5rem;
}

.theme-option {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: 2px solid transparent;
    cursor: pointer;
    transition: all 0.15s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-weight: bold;
    font-size: calc(var(--h1) * 0.7);
}

.theme-option:hover {
    transform: scale(1.1);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.theme-option.active {
    border-color: var(--gray-900);
    box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.1);
}

.loading {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(17, 24, 39, 0.5);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.spinner {
    border: 4px solid var(--gray-200);
    border-top: 4px solid var(--primary);
    border-radius: 50%;
    width: 50px;
    height: 50px;
    animation: spin 0.8s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

@keyframes swimAcross {
    0% { left: -2.5rem; }
    100% { left: 100%; }
}

@keyframes rankingsSlide {
    0% { transform: translateX(-120%); }
    100% { transform: translateX(500%); }
}

.loading p {
    color: white;
    margin-top: 1rem;
    font-size: calc(var(--h1) * 0.8);
    font-weight: 500;
}

.toast {
    position: fixed;
    bottom: max(1.5rem, calc(env(safe-area-inset-bottom) + 0.5rem));
    right: max(1.5rem, calc(env(safe-area-inset-right) + 0.5rem));
    max-width: 400px;
    padding: 1rem 1.25rem;
    background: var(--gray-800);
    color: white;
    border-radius: 6px;
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
    opacity: 0;
    transform: translateY(1rem);
    transition: all 0.2s ease;
    z-index: 1001;
    font-size: calc(var(--h1) * 0.75);
}

.toast.show {
    opacity: 1;
    transform: translateY(0);
}

.toast.success {
    background: var(--success);
}

.toast.error {
    background: var(--danger);
}

.ptr-indicator {
    position: fixed;
    top: -56px;
    left: 0;
    right: 0;
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 200;
    pointer-events: none;
    will-change: transform, opacity;
}

.ptr-icon {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: var(--bg-primary);
    border: 1px solid var(--gray-200);
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--gray-700);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
    transition: transform 0.15s ease, color 0.15s ease;
}

.ptr-icon.triggered {
    color: var(--primary);
    transform: rotate(180deg);
}

.ptr-icon.refreshing {
    color: var(--primary);
}

.install-prompt {
    position: fixed;
    bottom: max(1rem, calc(env(safe-area-inset-bottom) + 0.5rem));
    left: 50%;
    transform: translateX(-50%);
    max-width: min(500px, calc(100% - 2rem));
    width: max-content;
    padding: 0.75rem 0.85rem 0.75rem 1rem;
    background: var(--primary);
    color: #ffffff;
    border-radius: 10px;
    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.25);
    display: flex;
    align-items: center;
    gap: 0.75rem;
    z-index: 1000;
    font-size: 0.95rem;
}

.install-prompt-text {
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.install-prompt-btn {
    background: #ffffff;
    color: var(--primary);
    border: none;
    padding: 0.45rem 0.95rem;
    border-radius: 6px;
    font-weight: 600;
    font-size: 0.9rem;
    cursor: pointer;
    white-space: nowrap;
}

.install-prompt-btn:hover {
    filter: brightness(0.95);
}

.install-prompt-btn-block {
    display: block;
    width: 100%;
    margin-top: 0.5rem;
    padding: 0.6rem 1rem;
    background: var(--primary);
    color: #ffffff;
}

.install-prompt-close {
    background: transparent;
    color: #ffffff;
    border: none;
    font-size: 1.5rem;
    line-height: 1;
    cursor: pointer;
    padding: 0 0.25rem;
    opacity: 0.8;
}

.install-prompt-close:hover {
    opacity: 1;
}

.install-prompt-modal {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.55);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1002;
    padding: 1rem;
}

.install-prompt-modal-content {
    background: var(--bg-primary);
    color: var(--text-primary);
    padding: 1.5rem;
    border-radius: 12px;
    max-width: 420px;
    width: 100%;
    box-shadow: 0 20px 40px -10px rgba(0, 0, 0, 0.35);
}

.install-prompt-modal-content h3 {
    margin: 0 0 0.75rem;
    color: var(--primary);
}

.install-prompt-modal-content ol {
    margin: 0;
    padding-left: 1.25rem;
    line-height: 1.7;
    color: var(--text-primary);
}

.bottom-nav {
    display: none;
}

.header-theme {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
}

.empty-state {
    text-align: center;
    padding: 3rem 1.5rem;
    color: var(--gray-600);
    background: var(--gray-50);
    border-radius: 6px;
    border: 1px solid var(--gray-200);
}

.empty-state p {
    font-size: calc(var(--h1) * 0.75);
    margin: 0;
}

::-webkit-scrollbar {
    width: 8px;
    height: 8px;
}

::-webkit-scrollbar-track {
    background: var(--gray-100);
}

::-webkit-scrollbar-thumb {
    background: var(--gray-300);
    border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
    background: var(--gray-400);
}

.auth-service-banner {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.6rem 1rem;
    margin-bottom: 1rem;
    background: rgba(59, 130, 246, 0.08);
    border: 1px solid rgba(37, 99, 235, 0.25);
    border-radius: 8px;
    font-size: 0.9rem;
    color: var(--gray-700, #374151);
    flex-wrap: wrap;
}

.auth-service-banner-text {
    flex: 1 1 auto;
    min-width: 0;
    line-height: 1.4;
}

.auth-service-banner-text strong {
    color: var(--primary);
}

.auth-service-banner-dismiss {
    width: 28px;
    height: 28px;
    padding: 0;
    border: none;
    background: transparent;
    color: var(--gray-500, #6b7280);
    font-size: 1.4rem;
    line-height: 1;
    cursor: pointer;
    border-radius: 50%;
    flex-shrink: 0;
    transition: background 0.15s ease;
}

.auth-service-banner-dismiss:hover {
    background: rgba(0, 0, 0, 0.06);
}

.guest-banner {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.6rem 1rem;
    margin-bottom: 1rem;
    background: rgba(59, 130, 246, 0.08);
    border: 1px solid rgba(37, 99, 235, 0.25);
    border-radius: 8px;
    font-size: 0.9rem;
    color: var(--gray-700, #374151);
    flex-wrap: wrap;
}

.guest-banner-text {
    flex: 1 1 auto;
    min-width: 0;
    line-height: 1.4;
}

.guest-banner-text strong {
    color: var(--primary);
}

.guest-banner-signin {
    padding: 0.4rem 0.9rem;
    border-radius: 999px;
    border: 1px solid var(--primary);
    background: var(--primary);
    color: #fff;
    font-weight: 600;
    cursor: pointer;
    flex-shrink: 0;
    transition: background 0.15s ease, transform 0.15s ease;
}

.guest-banner-signin:hover {
    background: var(--primary-dark, #2563eb);
}

.guest-banner-signin:active {
    transform: translateY(1px);
}

.guest-banner-dismiss {
    width: 28px;
    height: 28px;
    padding: 0;
    border: none;
    background: transparent;
    color: var(--gray-500, #6b7280);
    font-size: 1.4rem;
    line-height: 1;
    cursor: pointer;
    border-radius: 50%;
    flex-shrink: 0;
    transition: background 0.15s ease;
}

.guest-banner-dismiss:hover {
    background: rgba(0, 0, 0, 0.06);
}

.notification-banner {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.6rem 1rem;
    margin-bottom: 1rem;
    background: rgba(34, 197, 94, 0.08);
    border: 1px solid rgba(34, 197, 94, 0.25);
    border-radius: 8px;
    font-size: 0.9rem;
    color: var(--gray-700, #374151);
    flex-wrap: wrap;
}

.notification-banner-text {
    flex: 1 1 auto;
    min-width: 0;
    line-height: 1.4;
}

.notification-banner-text strong {
    color: var(--success, #22c55e);
}

.notification-banner-enable {
    padding: 0.4rem 0.9rem;
    border-radius: 999px;
    border: 1px solid var(--success, #22c55e);
    background: var(--success, #22c55e);
    color: #fff;
    font-weight: 600;
    cursor: pointer;
    flex-shrink: 0;
    transition: background 0.15s ease, transform 0.15s ease;
}

.notification-banner-enable:hover {
    background: #16a34a;
}

.notification-banner-enable:active {
    transform: translateY(1px);
}

.notification-banner-dismiss {
    width: 28px;
    height: 28px;
    padding: 0;
    border: none;
    background: transparent;
    color: var(--gray-500, #6b7280);
    font-size: 1.4rem;
    line-height: 1;
    cursor: pointer;
    border-radius: 50%;
    flex-shrink: 0;
    transition: background 0.15s ease;
}

.notification-banner-dismiss:hover {
    background: rgba(0, 0, 0, 0.06);
}

.notification-banner-inbox {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.4rem 0.9rem;
    border: 1px solid var(--border-color);
    border-radius: 999px;
    background: var(--surface-secondary);
    color: var(--text-primary);
    font-size: 0.875rem;
    cursor: pointer;
    margin-bottom: 0.75rem;
}

.notification-banner-inbox:hover {
    background: var(--gray-100);
}

.notification-banner-badge {
    position: absolute;
    top: -4px;
    right: -6px;
    min-width: 16px;
    height: 16px;
    padding: 0 3px;
    background: var(--primary);
    color: #fff;
    border-radius: 8px;
    font-size: 0.6rem;
    font-weight: 700;
    line-height: 16px;
    text-align: center;
    pointer-events: none;
}

.offline-banner {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.6rem 1rem;
    margin-bottom: 1rem;
    background: rgba(245, 158, 11, 0.12);
    border: 1px solid rgba(217, 119, 6, 0.35);
    border-radius: 8px;
    font-size: 0.9rem;
    color: var(--gray-700, #374151);
}

.offline-banner-text {
    flex: 1 1 auto;
    line-height: 1.4;
}

.update-banner {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.6rem 1rem;
    margin-bottom: 1rem;
    background: rgba(59, 130, 246, 0.35);
    border: 1px solid rgba(59, 130, 246, 0.35);
    border-radius: 0.9rem;
    font-size: 0.9rem;
    color: var(--gray-700, #374151);
}

.update-banner-text {
    flex: 1 1 auto;
    line-height: 1.4;
}

.update-banner-btn {
    flex-shrink: 0;
    padding: 0.3rem 0.75rem;
    background: var(--primary, #3b82f6);
    color: #fff;
    border: none;
    border-radius: 6px;
    font-size: 0.85rem;
    cursor: pointer;
    font-weight: 500;
}

.update-banner-btn:hover {
    opacity: 0.88;
}

.update-banner-spinner {
    width: 1rem;
    height: 1rem;
    border: 2px solid rgba(255, 255, 255, 0.45);
    border-top-color: rgba(255, 255, 255, 0.95);
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
}

.update-banner-close {
    flex-shrink: 0;
    width: 1.5rem;
    height: 1.5rem;
    padding: 0;
    background: transparent;
    border: none;
    font-size: 1.25rem;
    color: var(--gray-600, #4b5563);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
}

.update-banner-close:hover {
    color: var(--gray-900, #111827);
}

.notification-delete-btn {
    display: none;
    color: var(--text-secondary);
    padding: 0.25rem 0.4rem;
    font-size: 0.8rem;
    line-height: 1;
}

.notification-delete-btn:hover {
    color: var(--danger);
}

@media (pointer: fine) {
    .notification-delete-btn {
        display: flex;
        align-items: center;
    }
}
`, "",{"version":3,"sources":["webpack://./src/renderer/styles/components.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,6BAA6B;IAC7B,2CAA2C;IAC3C,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,0BAA0B;IAC1B,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,+BAA+B;IAC/B,wCAAwC;IACxC,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,kCAAkC;IAClC,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,yBAAyB;AAC7B;;AAEA;IACI,0CAA0C;IAC1C,+BAA+B;IAC/B,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,4BAA4B;IAC5B,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,4BAA4B;IAC5B,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,+BAA+B;IAC/B,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,4BAA4B;IAC5B,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;;IAEI,sBAAsB;IACtB,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,iCAAiC;IACjC,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB,6BAA6B;IAC7B,0DAA0D;AAC9D;;AAEA;;IAEI,6BAA6B;AACjC;;AAEA;;IAEI,aAAa;IACb,4BAA4B;IAC5B,4CAA4C;AAChD;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,OAAO;IACP,QAAQ;IACR,WAAW;IACX,SAAS;IACT,gBAAgB;IAChB,gBAAgB;IAChB,6BAA6B;IAC7B,iCAAiC;IACjC,kBAAkB;IAClB,0CAA0C;IAC1C,iBAAiB;IACjB,gBAAgB;IAChB,iCAAiC;IACjC,4BAA4B;AAChC;;AAEA;IACI,cAAc;IACd,WAAW;IACX,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,0BAA0B;IAC1B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;IACZ,0BAA0B;IAC1B,YAAY;IACZ,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;IAChC,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,SAAS;IACT,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,yBAAyB;IACzB,6BAA6B;IAC7B,YAAY;IACZ,oCAAoC;IACpC,0CAA0C;IAC1C,SAAS;IACT,oCAAoC;AACxC;;AAEA;IACI,OAAO,2BAA2B,EAAE,UAAU,EAAE;IAChD,OAAO,wBAAwB,KAAK,UAAU,EAAE;AACpD;;AAEA;IACI,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,uHAAuH;IACvH,yEAAyE;IACzE,mBAAmB;IACnB,qCAAqC;IACrC,4CAA4C;IAC5C,gBAAgB;IAChB,uGAAuG;AAC3G;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,SAAS;IACT,UAAU;IACV,qGAAqG;AACzG;;AAEA;IACI,4BAA4B;IAC5B,6CAA6C;AACjD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,gCAAgC;IAChC,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,MAAM;AACV;;AAEA;IACI,sBAAsB;IACtB,gCAAgC;IAChC,YAAY;IACZ,wBAAwB;AAC5B;;AAEA;;IAEI,UAAU;AACd;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,iCAAiC;IACjC,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,gCAAgC;IAChC,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,aAAa;IACb,kBAAkB;IAClB,qBAAqB;IACrB,iCAAiC;IACjC,aAAa;IACb,WAAW;IACX,2DAA2D;AAC/D;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,sBAAsB;IACtB,iCAAiC;IACjC,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,oCAAoC;AACxC;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,+BAA+B;IAC/B,kBAAkB;IAClB,6BAA6B;IAC7B,0BAA0B;IAC1B,OAAO;IACP,YAAY;IACZ,gBAAgB;IAChB,oCAAoC;IACpC,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,uBAAuB;IACvB,qBAAqB;IACrB,uBAAuB;IACvB,oBAAoB;IACpB,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,0BAA0B;IAC1B,iCAAiC;AACrC;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,MAAM;IACN,qBAAqB;IACrB,wCAAwC;AAC5C;;AAEA;IACI,uBAAuB;IACvB,uBAAuB;IACvB,sBAAsB;IACtB,YAAY;IACZ,oCAAoC;IACpC,eAAe;IACf,gBAAgB;IAChB,iCAAiC;IACjC,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;IACtB,0BAA0B;AAC9B;;AAEA;IACI,qBAAqB;IACrB,mCAAmC;AACvC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,qBAAqB;IACrB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,gCAAgC;IAChC,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,mCAAmC;AACvC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,cAAc;IACd,2BAA2B;IAC3B,WAAW;IACX,iBAAiB;IACjB,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,+BAA+B;IAC/B,uCAAuC;IACvC,mCAAmC;AACvC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,cAAc;IACd,2BAA2B;IAC3B,WAAW;IACX,iBAAiB;IACjB,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,wBAAwB;IACxB,gBAAgB;IAChB,WAAW;IACX,oBAAoB;IACpB,4BAA4B;IAC5B,qBAAqB;IACrB,yDAAiU;IACjU,4BAA4B;IAC5B,yCAAyC;IACzC,wBAAwB;AAC5B;;AAEA;IACI,yDAAmU;AACvU;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,wBAAwB;IACxB,4BAA4B;IAC5B,0BAA0B;IAC1B,iCAAiC;IACjC,kBAAkB;IAClB,iCAAiC;IACjC,eAAe;IACf,mCAAmC;IACnC,sBAAsB;IACtB,0BAA0B;IAC1B,yDAA+S;IAC/S,4BAA4B;IAC5B,yCAAyC;IACzC,wBAAwB;AAC5B;;AAEA;IACI,6BAA6B;IAC7B,6BAA6B;IAC7B,yDAA+S;IAC/S,4BAA4B;IAC5B,yCAAyC;IACzC,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,4BAA4B;IAC5B,4CAA4C;AAChD;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,6BAA6B;IAC7B,yDAA+U;IAC/U,4BAA4B;IAC5B,yCAAyC;IACzC,wBAAwB;AAC5B;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,OAAO;IACP,QAAQ;IACR,WAAW;IACX,6BAA6B;IAC7B,iCAAiC;IACjC,kBAAkB;IAClB,0CAA0C;IAC1C,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,QAAQ;IACR,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,sBAAsB;IACtB,YAAY;IACZ,uBAAuB;IACvB,sBAAsB;IACtB,iCAAiC;IACjC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,mCAAmC;IACnC,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,0BAA0B;IAC1B,4BAA4B;AAChC;;AAEA;IACI,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,sBAAsB;IACtB,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;IACrB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,8BAA8B;IAC9B,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,WAAW;IACX,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,gDAAgD;IAChD,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,uBAAuB;IACvB,wBAAwB;IACxB,6BAA6B;IAC7B,oBAAoB;IACpB,2BAA2B;IAC3B,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;IAChB,eAAe;IACf,4EAA4E;AAChF;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,uBAAuB;IACvB,wBAAwB;IACxB,6BAA6B;IAC7B,oBAAoB;IACpB,2BAA2B;IAC3B,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;IAChB,eAAe;IACf,4EAA4E;AAChF;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,yEAAyE;IACzE,2EAA2E;IAC3E,kEAAkE;AACtE;;AAEA;IACI,yEAAyE;AAC7E;;AAEA;IACI,uBAAuB;IACvB,6BAA6B;IAC7B,oBAAoB;IACpB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;;IAEI,uBAAuB;IACvB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;IACxB,iCAAiC;IACjC,kBAAkB;IAClB,6BAA6B;IAC7B,sBAAsB;IACtB,iBAAiB;IACjB,eAAe;IACf,4EAA4E;AAChF;;AAEA;IACI,4BAA4B;IAC5B,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;IAC1B,4BAA4B;IAC5B,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,2DAA2D;IAC3D,6BAA6B;IAC7B,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,eAAe;AACnB;;AAEA;;IAEI,uBAAuB;IACvB,eAAe;IACf,iCAAiC;IACjC,oBAAoB;IACpB,6BAA6B;IAC7B,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,mGAAmG;IACnG,mBAAmB;AACvB;;AAEA;;IAEI,4BAA4B;IAC5B,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;IAC1B,4BAA4B;IAC5B,YAAY;IACZ,4CAA4C;AAChD;;AAEA;;IAEI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA;;IAEI,mBAAmB;IACnB,4BAA4B;IAC5B,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;IAC1B,iCAAiC;IACjC,kBAAkB;IAClB,iCAAiC;IACjC,eAAe;IACf,6BAA6B;IAC7B,sBAAsB;IACtB,0BAA0B;AAC9B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,4BAA4B;IAC5B,4CAA4C;AAChD;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,iCAAiC;AACrC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,iCAAiC;AACrC;;AAEA;IACI,0BAA0B;IAC1B,sBAAsB;IACtB,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;IAChB,gCAAgC;IAChC,wCAAwC;AAC5C;;AAEA;IACI,qBAAqB;IACrB,wCAAwC;IACxC,sBAAsB;AAC1B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;IACjB,cAAc;IACd,cAAc;IACd,wCAAwC;AAC5C;;AAEA;IACI,qBAAqB;AACzB;;AAEA;;IAEI,kCAAkC;IAClC,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,aAAa;IACb,6BAA6B;IAC7B,kBAAkB;IAClB,iCAAiC;IACjC,0BAA0B;AAC9B;;AAEA;IACI,4BAA4B;IAC5B,6CAA6C;AACjD;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;IACjC,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,6BAA6B;IAC7B,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,uBAAuB;IACvB,gBAAgB;IAChB,2BAA2B;IAC3B,qCAAqC;IACrC,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,4BAA4B;AAChC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,SAAS;IACT,iCAAiC;IACjC,gBAAgB;IAChB,sBAAsB;IACtB,OAAO;IACP,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,MAAM;IACN,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,qCAAqC;IACrC,wCAAwC;IACxC,kCAAkC;IAClC,eAAe;IACf,mDAAmD;AACvD;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,mCAAmC;IACnC,iCAAiC;AACrC;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,iCAAiC;IACjC,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,OAAO;IACP,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,gCAAgC;IAChC,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,gCAAgC;IAChC,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,gCAAgC;IAChC,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,iCAAiC;AACrC;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,oCAAoC;IACpC,mBAAmB;IACnB,YAAY;IACZ,8BAA8B;IAC9B,yEAAyE;IACzE,mBAAmB;IACnB;;yBAEqB;IACrB,6CAA6C;IAC7C,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,+BAA+B;AACnC;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,aAAa;IACb,qBAAqB;IACrB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,qEAAqE;IACrE,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,iCAAiC;IACjC,gBAAgB;IAChB,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,SAAS;IACT,iCAAiC;IACjC,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,yEAAyE;IACzE,oBAAoB;IACpB,6BAA6B;IAC7B,qBAAqB;IACrB,iCAAiC;IACjC,gBAAgB;IAChB,eAAe;IACf,wEAAwE;AAC5E;;AAEA;IACI,0BAA0B;IAC1B,WAAW;IACX,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,UAAU;IACV,SAAS;IACT,oBAAoB;IACpB,yEAAyE;IACzE,6BAA6B;IAC7B,qBAAqB;IACrB,iBAAiB;IACjB,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,iGAAiG;IACjG,UAAU;AACd;;AAEA;IACI,0BAA0B;IAC1B,4BAA4B;IAC5B,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,OAAO;IACP,QAAQ;IACR,aAAa;IACb,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,oBAAoB;IACpB,YAAY;IACZ,UAAU;IACV,mEAAmE;IACnE,eAAe;IACf,uDAAuD;AAC3D;;AAEA;IACI,0BAA0B;IAC1B,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,uBAAuB;IACvB,wCAAwC;IACxC,2BAA2B;IAC3B,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gCAAgC;IAChC,gBAAgB;IAChB,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,gCAAgC;IAChC,sBAAsB;IACtB,OAAO;IACP,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;IACtB,iCAAiC;IACjC,cAAc;AAClB;;AAEA;IACI,0BAA0B;IAC1B,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;IACvB,qBAAqB;IACrB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,WAAW;IACX,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,uHAAuH;IACvH,yEAAyE;IACzE,mBAAmB;IACnB,qCAAqC;IACrC,4CAA4C;IAC5C,gBAAgB;IAChB,uGAAuG;AAC3G;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,SAAS;IACT,UAAU;IACV,qGAAqG;AACzG;;AAEA;IACI,4BAA4B;IAC5B,6CAA6C;AACjD;;AAEA;IACI,4BAA4B;IAC5B,+JAA+J;AACnK;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,iCAAiC;IACjC,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,gCAAgC;IAChC,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,MAAM;AACV;;AAEA;IACI,sBAAsB;IACtB,gCAAgC;IAChC,YAAY;IACZ,wBAAwB;AAC5B;;AAEA;;IAEI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,iCAAiC;IACjC,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,0CAA0C;AAC9C;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,iCAAiC;IACjC,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,WAAW;IACX,YAAY;IACZ,0BAA0B;IAC1B,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gCAAgC;IAChC,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,OAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,cAAc;IACd,2BAA2B;IAC3B,WAAW;IACX,iBAAiB;IACjB,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,wBAAwB;IACxB,gBAAgB;IAChB,WAAW;IACX,oBAAoB;IACpB,4BAA4B;IAC5B,qBAAqB;IACrB,yDAA+S;IAC/S,4BAA4B;IAC5B,yCAAyC;IACzC,wBAAwB;AAC5B;;AAEA;IACI,yDAAmU;AACvU;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,OAAO;IACP,WAAW;AACf;;AAEA;IACI,UAAU;IACV,uBAAuB;IACvB,oBAAoB;IACpB,WAAW;AACf;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;IACZ,sBAAsB;IACtB,0BAA0B;IAC1B,YAAY;IACZ,mBAAmB;IACnB,gCAAgC;IAChC,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,UAAU;IACV,cAAc;IACd,iCAAiC;IACjC,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,iDAAiD;IACjD,qCAAqC;IACrC,OAAO;IACP,uBAAuB;IACvB,iCAAiC;IACjC,2BAA2B;IAC3B,iCAAiC;IACjC,kBAAkB;IAClB,eAAe;IACf,0BAA0B;IAC1B,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,OAAO;IACP,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,OAAO;IACP,eAAe;IACf,iCAAiC;IACjC,gCAAgC;IAChC,kBAAkB;IAClB,YAAY;IACZ,QAAQ;IACR,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,4CAA4C;AAChD;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,cAAc;IACd,2BAA2B;IAC3B,WAAW;IACX,iBAAiB;IACjB,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gCAAgC;IAChC,8BAA8B;IAC9B,wCAAwC;IACxC,mCAAmC;AACvC;;AAEA;;IAEI,kBAAkB;IAClB,QAAQ;IACR,aAAa;IACb,2BAA2B;IAC3B,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,cAAc;IACd,YAAY;IACZ,oBAAoB;IACpB,uBAAuB;IACvB,sBAAsB;IACtB,eAAe;IACf,yDAAyD;AAC7D;;AAEA;;IAEI,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA;;IAEI,uCAAuC;AAC3C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,OAAO;IACP,gBAAgB;IAChB,aAAa;IACb,0BAA0B;IAC1B,kBAAkB;IAClB,qCAAqC;AACzC;;AAEA;IACI,cAAc;IACd,gCAAgC;IAChC,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,gCAAgC;IAChC,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;IAChC,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,6BAA6B;IAC7B,eAAe;IACf,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;IACrB,wCAAwC;AAC5C;;AAEA;IACI,6BAA6B;IAC7B,wCAAwC;AAC5C;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,iCAAiC;IACjC,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,iCAAiC;IACjC,oCAAoC;IACpC,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,oCAAoC;AACxC;;AAEA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,KAAK,aAAa,EAAE;IACpB,OAAO,UAAU,EAAE;AACvB;;AAEA;IACI,KAAK,4BAA4B,EAAE;IACnC,OAAO,2BAA2B,EAAE;AACxC;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,+DAA+D;IAC/D,6DAA6D;IAC7D,gBAAgB;IAChB,qBAAqB;IACrB,2BAA2B;IAC3B,YAAY;IACZ,kBAAkB;IAClB,+CAA+C;IAC/C,UAAU;IACV,2BAA2B;IAC3B,yBAAyB;IACzB,aAAa;IACb,iCAAiC;AACrC;;AAEA;IACI,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,UAAU;IACV,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,oBAAoB;IACpB,+BAA+B;AACnC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,6BAA6B;IAC7B,iCAAiC;IACjC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,yCAAyC;IACzC,kDAAkD;AACtD;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,6DAA6D;IAC7D,SAAS;IACT,2BAA2B;IAC3B,wCAAwC;IACxC,kBAAkB;IAClB,qCAAqC;IACrC,0BAA0B;IAC1B,cAAc;IACd,mBAAmB;IACnB,gDAAgD;IAChD,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,OAAO;IACP,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,YAAY;IACZ,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,oBAAoB;IACpB,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,cAAc;IACd,YAAY;IACZ,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,6BAA6B;IAC7B,0BAA0B;IAC1B,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX,iDAAiD;AACrD;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,SAAS;IACT,qBAAqB;IACrB,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,sBAAsB;IACtB,0BAA0B;IAC1B,kBAAkB;IAClB,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;IACjC,SAAS;AACb;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,oCAAoC;IACpC,yCAAyC;IACzC,kBAAkB;IAClB,iBAAiB;IACjB,+BAA+B;IAC/B,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;IACV,YAAY;IACZ,uBAAuB;IACvB,+BAA+B;IAC/B,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,iCAAiC;AACrC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,oCAAoC;IACpC,yCAAyC;IACzC,kBAAkB;IAClB,iBAAiB;IACjB,+BAA+B;IAC/B,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;IACtB,oBAAoB;IACpB,gCAAgC;IAChC,0BAA0B;IAC1B,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,uDAAuD;AAC3D;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;IACV,YAAY;IACZ,uBAAuB;IACvB,+BAA+B;IAC/B,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,iCAAiC;AACrC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,mCAAmC;IACnC,yCAAyC;IACzC,kBAAkB;IAClB,iBAAiB;IACjB,+BAA+B;IAC/B,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;IACtB,oBAAoB;IACpB,yCAAyC;IACzC,mCAAmC;IACnC,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,uDAAuD;AAC3D;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;IACV,YAAY;IACZ,uBAAuB;IACvB,+BAA+B;IAC/B,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,iCAAiC;AACrC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,sBAAsB;IACtB,qCAAqC;IACrC,oBAAoB;IACpB,oCAAoC;IACpC,0BAA0B;IAC1B,mBAAmB;IACnB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,eAAe;IACf,YAAY;IACZ,cAAc;IACd,0BAA0B;IAC1B,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,oBAAoB;IACpB,mBAAmB;IACnB,oCAAoC;IACpC,yCAAyC;IACzC,kBAAkB;IAClB,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,oCAAoC;IACpC,0CAA0C;IAC1C,qBAAqB;IACrB,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,uBAAuB;IACvB,mCAAmC;IACnC,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,2CAA2C;IAC3C,2CAA2C;IAC3C,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA;IACI,cAAc;IACd,aAAa;IACb,cAAc;IACd,UAAU;IACV,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,+BAA+B;IAC/B,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,4BAA4B;IAC5B,uBAAuB;IACvB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI;QACI,aAAa;QACb,mBAAmB;IACvB;AACJ","sourcesContent":[".modal-backdrop {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.7);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n}\n\n.modal {\n    background: var(--bg-primary);\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    border-radius: 12px;\n    width: min(90vw, 520px);\n    max-height: 85vh;\n    padding: 18px;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n}\n\n.modal-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 1rem;\n}\n\n.modal-header h3 {\n    margin: 0;\n    font-size: 1.1rem;\n    color: var(--text-primary);\n}\n\n.modal-close {\n    background: transparent;\n    border: none;\n    color: var(--text-primary);\n    font-size: 1.35rem;\n    cursor: pointer;\n}\n\n.modal-body {\n    overflow-y: auto;\n    max-height: 50vh;\n    padding-right: 8px;\n    color: var(--text-primary);\n}\n\n.standards-list {\n    display: grid;\n    gap: 10px;\n    margin-top: 12px;\n}\n\n.standards-item {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    padding: 10px 12px;\n    border-radius: 8px;\n    background: var(--bg-secondary);\n    border: 1px solid rgba(255,255,255,0.08);\n    cursor: pointer;\n}\n\n.standards-item input {\n    cursor: pointer;\n}\n\n.empty-standards {\n    padding: 14px;\n    border-radius: 8px;\n    background: rgba(255,255,255,0.05);\n    color: var(--text-secondary);\n}\n\n.modal-actions {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px;\n    justify-content: flex-end;\n}\n\n.pending-load-item {\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    background: var(--bg-secondary);\n    border-radius: 10px;\n    padding: 14px 16px;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.pending-load-item + .pending-load-item {\n    margin-top: 8px;\n}\n\n.pending-load-note {\n    color: var(--text-secondary);\n    font-size: 0.88rem;\n    line-height: 1.4;\n    margin-bottom: 10px;\n}\n\n.pending-load-item-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 0.5rem;\n    min-width: 0;\n}\n\n.pending-load-item-number {\n    font-size: 0.85rem;\n    color: var(--text-secondary);\n    font-weight: 600;\n    flex-shrink: 0;\n}\n\n.pending-load-source {\n    color: var(--text-secondary);\n    font-size: 0.8rem;\n    font-style: italic;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    min-width: 0;\n}\n\n.pending-load-name-row {\n    display: grid;\n    grid-template-columns: 1fr 90px;\n    gap: 0.75rem;\n}\n\n.pending-load-field {\n    display: flex;\n    flex-direction: column;\n    gap: 0.3rem;\n}\n\n.pending-load-field > span {\n    color: var(--text-secondary);\n    font-size: 0.8rem;\n    font-weight: 500;\n}\n\n.pending-load-field input,\n.pending-load-field select {\n    box-sizing: border-box;\n    width: 100%;\n    height: 2.5rem;\n    padding: 0 0.75rem;\n    border: 1px solid var(--gray-900);\n    border-radius: 6px;\n    font-size: 0.9rem;\n    color: var(--gray-900);\n    background: var(--bg-primary);\n    transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.pending-load-field input:hover,\n.pending-load-field select:hover {\n    border-color: var(--gray-400);\n}\n\n.pending-load-field input:focus,\n.pending-load-field select:focus {\n    outline: none;\n    border-color: var(--primary);\n    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);\n}\n\n.club-autocomplete {\n    position: relative;\n}\n\n.club-autocomplete-list {\n    position: absolute;\n    top: calc(100% + 4px);\n    left: 0;\n    right: 0;\n    z-index: 20;\n    margin: 0;\n    padding: 0.25rem;\n    list-style: none;\n    background: var(--bg-primary);\n    border: 1px solid var(--gray-200);\n    border-radius: 6px;\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);\n    max-height: 220px;\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n    overscroll-behavior: contain;\n}\n\n.club-autocomplete-option {\n    display: block;\n    width: 100%;\n    padding: 0.5rem 0.6rem;\n    border: none;\n    border-radius: 4px;\n    background: transparent;\n    color: var(--text-primary);\n    font-size: 0.85rem;\n    text-align: left;\n    cursor: pointer;\n}\n\n.club-autocomplete-option:hover {\n    background: var(--gray-50);\n}\n\n.action-buttons {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    gap: 0.25rem;\n    padding: 5px 0;\n}\n\n.btn-save-prominent {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.45rem;\n    background: var(--success);\n    color: white;\n    border: none;\n    padding: 0.5rem 0.9rem;\n    border-radius: 6px;\n    font-weight: 600;\n    font-size: calc(var(--h1) * 0.7);\n    cursor: pointer;\n    margin-right: auto;\n}\n\n.btn-save-prominent:hover:not(:disabled) {\n    background: #047857;\n}\n\n.btn-save-prominent.is-saved {\n    background: transparent;\n    color: var(--success);\n}\n\n.btn-save-prominent:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n\n.comparison-action-bar {\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    z-index: 100;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0.875rem 1.25rem;\n    background: var(--bg-primary);\n    opacity: 0.9;\n    border-top: 2px solid var(--primary);\n    box-shadow: 0 -4px 24px rgba(0, 0, 0, 0.2);\n    gap: 1rem;\n    animation: slideUpBar 0.22s ease-out;\n}\n\n@keyframes slideUpBar {\n    from { transform: translateY(100%); opacity: 0; }\n    to   { transform: translateY(0);    opacity: 1; }\n}\n\n.comparison-action-count {\n    font-size: 0.875rem;\n    color: var(--text-secondary);\n}\n\n.comparison-action-buttons {\n    display: flex;\n    gap: 0.5rem;\n}\n\n.saved-section.has-action-bar {\n    padding-bottom: 5rem;\n}\n\n#searchResults {\n    display: grid;\n    gap: 0.75rem;\n    min-width: 0;\n    overflow: hidden;\n}\n\n.swimmer-result {\n    position: relative;\n    background: linear-gradient(145deg, color-mix(in srgb, var(--primary) 7%, var(--bg-primary)) 0%, var(--bg-primary) 70%);\n    border: 1px solid color-mix(in srgb, var(--primary) 20%, var(--gray-200));\n    border-radius: 10px;\n    padding: 0.45rem 0.65rem 0.45rem 1rem;\n    box-shadow: 0 2px 8px rgba(16, 24, 40, 0.05);\n    overflow: hidden;\n    transition: transform 0.25s ease, border-color 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;\n}\n\n.swimmer-result::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    width: 3px;\n    background: linear-gradient(to bottom, var(--primary), color-mix(in srgb, var(--primary) 55%, white));\n}\n\n.swimmer-result:hover {\n    border-color: var(--primary);\n    box-shadow: 0 4px 14px rgba(16, 24, 40, 0.09);\n}\n\n.swimmer-result-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 0.25rem;\n}\n\n.swimmer-result-header h3 {\n    margin: 0;\n    font-size: calc(var(--h1) * 0.8);\n    color: var(--gray-900);\n    font-weight: 600;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    min-width: 0;\n}\n\n.swimmer-result-card-actions {\n    display: flex;\n    align-items: center;\n    flex-shrink: 0;\n    gap: 0;\n}\n\n.swimmer-result-card-actions .btn-ghost {\n    padding: 0.2rem 0.3rem;\n    font-size: calc(var(--h1) * 0.7);\n    opacity: 0.6;\n    transition: opacity 0.1s;\n}\n\n.swimmer-result:hover .swimmer-result-card-actions .btn-ghost,\n.swimmer-result-card-actions .btn-ghost:hover {\n    opacity: 1;\n}\n\n.swimmer-result-card-actions .swimmer-result-save {\n    color: var(--success);\n}\n\n.swimmer-result-card-actions .swimmer-result-save:disabled:not(.is-saved) {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n\n.swimmer-result-card-actions .swimmer-result-save.is-saved {\n    opacity: 1;\n    cursor: default;\n}\n\n.swimmer-result-meta {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 0.35rem;\n    margin-top: 0.2rem;\n}\n\n.swimmer-result-meta-text {\n    font-size: calc(var(--h1) * 0.65);\n    color: var(--gray-500);\n}\n\n.pagination-info {\n    color: var(--gray-600);\n    font-size: calc(var(--h1) * 0.7);\n    margin-bottom: 1rem;\n    text-align: center;\n}\n\n.pagination {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 1rem;\n    margin-top: 1.5rem;\n    padding: 1rem 0;\n}\n\n.pagination button {\n    padding: 0.5rem 1rem;\n    font-size: calc(var(--h1) * 0.7);\n    min-width: 100px;\n}\n\n.pagination span {\n    color: var(--gray-700);\n    font-weight: 500;\n}\n\n.swimmer-info {\n    background: var(--gray-50);\n    padding: 1rem;\n    border-radius: 6px;\n    margin-bottom: 1.5rem;\n    border: 1px solid var(--gray-200);\n    display: grid;\n    gap: 0.5rem;\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n}\n\n.swimmer-info p {\n    margin: 0;\n    padding: 0.1rem 0;\n    color: var(--gray-900);\n    font-size: calc(var(--h1) * 0.75);\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    border-bottom: 1px solid transparent;\n}\n\n.swimmer-info strong {\n    color: var(--primary);\n    font-weight: 600;\n    min-width: 120px;\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n    gap: 0.4rem;\n}\n\n.swimmer-info .info-select {\n    font-size: inherit;\n    padding: 0 0.3rem;\n    border: 1px solid var(--border);\n    border-radius: 4px;\n    background: var(--bg-primary);\n    color: var(--text-primary);\n    flex: 1;\n    min-width: 0;\n    max-width: 160px;\n    height: calc(var(--h1) * 0.75 * 1.5);\n    box-sizing: border-box;\n    line-height: normal;\n    appearance: none;\n}\n\n.swimmer-info .info-edit-button {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    border: none;\n    background: transparent;\n    color: var(--primary);\n    padding: 0.25rem 0.5rem;\n    margin-left: 0.25rem;\n    border-radius: 4px;\n    cursor: pointer;\n    opacity: 0.8;\n    transition: all 0.15s ease;\n    font-size: calc(var(--h1) * 0.75);\n}\n\n.swimmer-info .info-edit-button:hover,\n.swimmer-info .info-edit-button:focus-visible {\n    background: rgba(59, 130, 246, 0.08);\n}\n\n.swimmer-info .info-text {\n    color: var(--gray-900);\n    font-size: inherit;\n    line-height: 1.4;\n    flex: 1;\n    min-width: 0;\n}\n\n.swimmer-info .info-row {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    flex-wrap: wrap;\n}\n\n.tabs {\n    display: flex;\n    gap: 0;\n    margin-bottom: 1.5rem;\n    border-bottom: 1px solid var(--gray-200);\n}\n\n.tab-btn {\n    padding: 0.75rem 1.5rem;\n    background: transparent;\n    color: var(--gray-600);\n    border: none;\n    border-bottom: 2px solid transparent;\n    cursor: pointer;\n    font-weight: 500;\n    font-size: calc(var(--h1) * 0.75);\n    transition: all 0.15s;\n}\n\n.tab-btn:hover {\n    color: var(--gray-900);\n    background: var(--gray-50);\n}\n\n.tab-btn.active {\n    color: var(--primary);\n    border-bottom-color: var(--primary);\n}\n\n.tab-content {\n    display: none;\n}\n\n.tab-content.active {\n    display: block;\n}\n\n.filter-section {\n    display: flex;\n    gap: 1rem;\n    margin-bottom: 1.5rem;\n    flex-wrap: wrap;\n    align-items: end;\n}\n\n.filter-section > div {\n    display: flex;\n    flex-direction: column;\n    gap: 0.25rem;\n}\n\n.filter-section label {\n    font-size: calc(var(--h1) * 0.7);\n    font-weight: 500;\n    color: var(--gray-700);\n}\n\n.filter-section select {\n    min-width: 150px;\n}\n\n.filter-section input[type=\"text\"] {\n    min-width: 200px;\n}\n\n.search-controls {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    margin-bottom: 1.25rem;\n}\n\n.search-controls > button {\n    flex-shrink: 0;\n}\n\n.search-input-wrap {\n    position: relative;\n    flex: 1;\n    min-width: 0;\n}\n\n.search-input-wrap input {\n    width: 100%;\n    padding-inline-end: 2rem !important;\n}\n\n.search-filter-row {\n    width: 100%;\n}\n\n.search-filter-input-wrap {\n    position: relative;\n    min-width: 200px;\n}\n\n.search-filter-icon {\n    position: absolute;\n    top: 50%;\n    left: 0.875rem;\n    transform: translateY(-50%);\n    width: 1rem;\n    font-size: 0.9rem;\n    color: var(--gray-500);\n    pointer-events: none;\n}\n\n.search-filter-input {\n    width: 100%;\n    min-width: 100%;\n    padding-left: 2.5rem !important;\n    padding-inline-start: 2.5rem !important;\n    padding-inline-end: 2rem !important;\n}\n\n.rankings-county-filter {\n    position: relative;\n    min-width: 200px;\n}\n\n.rankings-county-icon {\n    position: absolute;\n    top: 50%;\n    left: 0.875rem;\n    transform: translateY(-50%);\n    width: 1rem;\n    font-size: 0.9rem;\n    color: var(--gray-500);\n    pointer-events: none;\n}\n\n.rankings-county-select {\n    min-width: 100%;\n    -webkit-appearance: none;\n    appearance: none;\n    width: 100%;\n    padding-left: 2.5rem;\n    padding-inline-start: 2.5rem;\n    padding-right: 2.5rem;\n    background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Cpath fill='%236b7280' d='M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z'/%3E%3C/svg%3E\");\n    background-repeat: no-repeat;\n    background-position: right 0.75rem center;\n    background-size: 0.75rem;\n}\n\n.rankings-county-select:focus {\n    background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Cpath fill='%236b7280' d='M278.6 105.4c-12.5-12.5-32.8-12.5-45.3 0l-192 192c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L256 173.3l169.4 169.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-192-192z'/%3E%3C/svg%3E\");\n}\n\n.age-multiselect-trigger {\n    width: 100%;\n    text-align: left;\n    padding: 0.625rem 2.5rem;\n    padding-inline-start: 2.5rem;\n    padding-inline-end: 2.5rem;\n    border: 1px solid var(--gray-300);\n    border-radius: 6px;\n    font-size: calc(var(--h1) * 0.75);\n    cursor: pointer;\n    background-color: var(--bg-primary);\n    color: var(--gray-900);\n    transition: all 0.15s ease;\n    background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Cpath fill='%236b7280' d='M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z'/%3E%3C/svg%3E\");\n    background-repeat: no-repeat;\n    background-position: right 0.75rem center;\n    background-size: 0.75rem;\n}\n\n.age-multiselect-trigger:hover:not(:disabled) {\n    border-color: var(--gray-400);\n    background-color: transparent;\n    background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Cpath fill='%236b7280' d='M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z'/%3E%3C/svg%3E\");\n    background-repeat: no-repeat;\n    background-position: right 0.75rem center;\n    background-size: 0.75rem;\n}\n\n.age-multiselect-trigger:focus {\n    outline: none;\n    border-color: var(--primary);\n    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);\n}\n\n.age-multiselect-trigger:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n\n.age-multiselect-trigger[aria-expanded=\"true\"] {\n    border-color: var(--gray-400);\n    background-color: transparent;\n    background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Cpath transform='rotate(180 256 256)' fill='%236b7280' d='M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z'/%3E%3C/svg%3E\");\n    background-repeat: no-repeat;\n    background-position: right 0.75rem center;\n    background-size: 0.75rem;\n}\n\n.age-multiselect-label {\n    display: block;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.age-multiselect-popover {\n    position: absolute;\n    top: calc(100% + 4px);\n    left: 0;\n    right: 0;\n    z-index: 50;\n    background: var(--bg-primary);\n    border: 1px solid var(--gray-300);\n    border-radius: 6px;\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);\n    padding: 0.35rem;\n    max-height: 280px;\n    overflow-y: auto;\n}\n\n.age-multiselect-popover-anchored {\n    left: auto;\n    right: 0;\n    width: max-content;\n    min-width: 10rem;\n}\n\n.age-multiselect-option {\n    display: flex;\n    align-items: center;\n    gap: 0.55rem;\n    width: 100%;\n    padding: 0.5rem 0.6rem;\n    border: none;\n    background: transparent;\n    color: var(--gray-900);\n    font-size: calc(var(--h1) * 0.75);\n    cursor: pointer;\n    border-radius: 4px;\n    text-align: left;\n}\n\n.age-multiselect-option:hover {\n    background: var(--bg-secondary);\n}\n\n.age-multiselect-check {\n    width: 1rem;\n    height: 1rem;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    border: 1.5px solid var(--gray-400);\n    border-radius: 3px;\n    flex-shrink: 0;\n    font-size: 0.6rem;\n    color: #fff;\n}\n\n.age-multiselect-option.selected .age-multiselect-check {\n    background: var(--primary);\n    border-color: var(--primary);\n}\n\n.age-multiselect-option.is-fixed {\n    cursor: default;\n    opacity: 0.65;\n}\n\n.age-multiselect-option.is-fixed:hover {\n    background: none;\n}\n\n.age-multiselect-locked {\n    margin-left: auto;\n    font-size: 0.68rem;\n    text-transform: uppercase;\n    letter-spacing: 0.03em;\n    color: var(--gray-400);\n}\n\n.filter-chip-label {\n    font-size: 0.65rem;\n    font-weight: 700;\n    letter-spacing: 0.06em;\n    color: var(--gray-400);\n    text-transform: uppercase;\n    white-space: nowrap;\n    flex-shrink: 0;\n}\n\n.filter-section .filter-chip-group {\n    flex-direction: row;\n    align-items: center;\n    gap: 0.35rem;\n}\n\n.filter-section .rankings-age-controls {\n    flex-direction: row;\n    align-items: center;\n    gap: 0.5rem;\n}\n\n.mobile-supplement {\n    display: none;\n}\n\n.card-event-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: baseline;\n    gap: 0.5rem;\n    white-space: nowrap;\n}\n\n.card-inline-time {\n    font-weight: 600;\n    white-space: nowrap;\n    flex-shrink: 0;\n}\n\n.card-meta-row {\n    font-size: 0.72rem;\n    color: var(--gray-400);\n    margin-top: 0.15rem;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.rank-card-sub {\n    display: flex;\n    align-items: baseline;\n    justify-content: space-between;\n    gap: 0.5rem;\n    margin-top: 0.1rem;\n    font-size: 0.72rem;\n    color: var(--gray-400);\n}\n\n.rank-card-course {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.rank-card-sub-right {\n    display: flex;\n    align-items: baseline;\n    gap: 0.4rem;\n    flex-shrink: 0;\n    white-space: nowrap;\n}\n\n.rank-card-fina {\n    font-weight: 600;\n    color: var(--gray-500);\n}\n\n.rank-card-grid {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 0.35rem 0.7rem;\n    margin-top: 0.6rem;\n}\n\n.rank-cell {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 0.4rem;\n    min-width: 0;\n}\n\n.rank-cell-label {\n    font-size: 0.65rem;\n    color: var(--gray-500);\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.rank-cell-value {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.25rem;\n    flex-shrink: 0;\n}\n\n.rank-cell-link {\n    color: var(--gray-400);\n    font-size: 0.6rem;\n    padding: 0.25rem;\n    line-height: 1;\n}\n\n.rank-cell-link:hover {\n    color: var(--primary);\n}\n\n.stroke-link {\n    color: var(--gray-400);\n    font-size: 0.6rem;\n    padding: 0.25rem;\n    line-height: 1;\n}\n\n.stroke-link:hover {\n    color: var(--primary);\n}\n\n.course-pill {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.3rem;\n    min-width: 2.1rem;\n    justify-content: center;\n    padding: 0.15rem 0.45rem;\n    border: 1px solid transparent;\n    border-radius: 999px;\n    background: var(--gray-100);\n    color: var(--gray-600);\n    font-size: 0.75rem;\n    font-weight: 700;\n    font-family: inherit;\n    line-height: 1.5;\n    cursor: default;\n    transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;\n}\n\n.rank-pill {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.3rem;\n    min-width: 2.9rem;\n    justify-content: center;\n    padding: 0.15rem 0.45rem;\n    border: 1px solid transparent;\n    border-radius: 999px;\n    background: var(--gray-100);\n    color: var(--gray-700);\n    font-size: 0.75rem;\n    font-weight: 700;\n    font-family: inherit;\n    line-height: 1.5;\n    cursor: pointer;\n    transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;\n}\n\n.rank-pill:disabled {\n    cursor: default;\n}\n\n.rank-pill:hover {\n    background-color: var(--gray-200);\n}\n\n.rank-pill-total {\n    font-weight: 500;\n    opacity: 0.75;\n}\n\n.rank-pill.is-strong {\n    background: color-mix(in srgb, var(--rank-strong) 20%, var(--bg-primary));\n    border-color: color-mix(in srgb, var(--rank-strong) 42%, var(--bg-primary));\n    color: color-mix(in srgb, var(--rank-strong) 68%, var(--gray-900));\n}\n\n.rank-pill.is-strong:hover {\n    background: color-mix(in srgb, var(--rank-strong) 30%, var(--bg-primary));\n}\n\n.rank-pill.is-empty {\n    background: transparent;\n    border-color: var(--gray-300);\n    border-style: dashed;\n    color: var(--gray-400);\n    font-weight: 500;\n}\n\n.rank-pill.is-unranked,\n.rank-pill.is-loading {\n    background: transparent;\n    color: var(--gray-400);\n    font-weight: 500;\n}\n\n@media (max-width: 330px) {\n    .rank-card-grid {\n        grid-template-columns: minmax(0, 1fr);\n    }\n}\n\n.filter-toggles {\n    display: flex;\n    gap: 0.35rem;\n    flex-wrap: wrap;\n}\n\n.filter-collapse-toggle {\n    display: none;\n}\n\n.filter-toggle {\n    padding: 0.25rem 0.55rem;\n    border: 1px solid var(--gray-300);\n    border-radius: 6px;\n    background: var(--bg-primary);\n    color: var(--gray-700);\n    font-size: 0.8rem;\n    cursor: pointer;\n    transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;\n}\n\n.filter-toggle:hover {\n    border-color: var(--primary);\n    color: var(--primary);\n}\n\n.filter-toggle.active {\n    background: var(--primary);\n    border-color: var(--primary);\n    color: white;\n}\n\n.filter-toggle-unavailable.active {\n    border-style: dashed;\n    border-color: color-mix(in srgb, white 55%, var(--primary));\n    text-decoration: line-through;\n    text-decoration-thickness: 1px;\n}\n\n.filter-toggle-unavailable.active:hover {\n    border-color: white;\n    color: white;\n}\n\n.segmented-toggle {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.4rem;\n    flex-wrap: wrap;\n}\n\n.segmented-toggle > button,\n.segmented-toggle .age-group-affordance {\n    padding: 0.3rem 0.85rem;\n    min-width: 3rem;\n    border: 1px solid var(--gray-300);\n    border-radius: 999px;\n    background: var(--bg-primary);\n    color: var(--gray-700);\n    font-size: 0.875rem;\n    font-weight: 500;\n    cursor: pointer;\n    transition: background 0.18s ease, color 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease;\n    white-space: nowrap;\n}\n\n.segmented-toggle > button:hover:not(.active):not(:disabled),\n.segmented-toggle .age-group-affordance:hover:not(:disabled) {\n    border-color: var(--primary);\n    color: var(--primary);\n}\n\n.segmented-toggle > button.active {\n    background: var(--primary);\n    border-color: var(--primary);\n    color: white;\n    box-shadow: 0 1px 4px rgba(37, 99, 235, 0.3);\n}\n\n.segmented-toggle > button:disabled,\n.segmented-toggle .age-group-affordance:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n\n.age-group-inline {\n    position: relative;\n    display: inline-flex;\n}\n\n.segmented-toggle .age-group-affordance {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.35rem;\n    border-style: dashed;\n    color: var(--gray-500);\n}\n\n.segmented-toggle .age-group-affordance:hover:not(:disabled),\n.segmented-toggle .age-group-affordance[aria-expanded=\"true\"] {\n    border-style: solid;\n    border-color: var(--primary);\n    color: var(--primary);\n}\n\n.comparison-controls {\n    display: flex;\n    gap: 0.75rem;\n    margin-bottom: 1.5rem;\n}\n\nselect {\n    padding: 0.625rem 0.875rem;\n    border: 1px solid var(--gray-300);\n    border-radius: 6px;\n    font-size: calc(var(--h1) * 0.75);\n    cursor: pointer;\n    background: var(--bg-primary);\n    color: var(--gray-900);\n    transition: all 0.15s ease;\n}\n\nselect:hover {\n    border-color: var(--gray-400);\n}\n\nselect:focus {\n    outline: none;\n    border-color: var(--primary);\n    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);\n}\n\n.table-container {\n    overflow-x: auto;\n    border-radius: 6px;\n    border: 1px solid var(--gray-200);\n}\n\n.splits-panel table {\n    font-size: calc(var(--h1) * 0.6);\n}\n\ntable {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: calc(var(--h1) * 0.75);\n}\n\ntable th {\n    background: var(--gray-50);\n    color: var(--gray-700);\n    padding: 0.75rem 1rem;\n    text-align: left;\n    font-weight: 600;\n    font-size: calc(var(--h1) * 0.7);\n    border-bottom: 1px solid var(--gray-200);\n}\n\ntable td {\n    padding: 0.75rem 1rem;\n    border-bottom: 1px solid var(--gray-200);\n    color: var(--gray-900);\n}\n\ntable tbody tr:hover {\n    background: var(--gray-50);\n}\n\ntable tbody tr:last-child td {\n    border-bottom: none;\n}\n\n.faster {\n    color: var(--success);\n    font-weight: 600;\n}\n\n.slower {\n    color: var(--danger);\n    font-weight: 600;\n}\n\n.section-toggle {\n    color: var(--gray-400);\n    padding: 0.375rem;\n    line-height: 1;\n    flex-shrink: 0;\n    -webkit-tap-highlight-color: transparent;\n}\n\n.section-toggle:hover:not(:disabled) {\n    color: var(--primary);\n}\n\n.section-toggle:hover:not(:disabled),\n.section-toggle:active:not(:disabled) {\n    background: transparent !important;\n    filter: none;\n    transform: none;\n}\n\n.chevron-icon {\n    transition: transform 0.2s ease;\n}\n\n.chevron-icon.expanded {\n    transform: rotate(180deg);\n}\n\n#savedSwimmers {\n    display: grid;\n    gap: 0.75rem;\n}\n\n.saved-swimmer {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 1rem;\n    padding: 1rem;\n    background: var(--bg-primary);\n    border-radius: 6px;\n    border: 1px solid var(--gray-200);\n    transition: all 0.15s ease;\n}\n\n.saved-swimmer:hover {\n    border-color: var(--primary);\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n}\n\n.saved-swimmer-info h4 {\n    color: var(--gray-900);\n    margin-bottom: 0.25rem;\n    font-size: calc(var(--h1) * 0.8);\n    font-weight: 600;\n}\n\n.saved-swimmer-info p {\n    color: var(--gray-600);\n    font-size: calc(var(--h1) * 0.65);\n}\n\n.club-group {\n    border: 1px solid var(--gray-200);\n    border-radius: 8px;\n    overflow: hidden;\n    max-width: 100%;\n}\n\n.club-group:hover {\n    border-color: var(--gray-400);\n    opacity: 1;\n}\n\n.club-group-spaced {\n    margin-top: 0.75rem;\n}\n\n.club-group .table-container {\n    border: none;\n    border-radius: 0;\n    overflow-x: auto;\n}\n\n.club-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0.5rem 0.75rem;\n    margin-bottom: 0;\n    background: var(--gray-100);\n    border-left: 3px solid var(--primary);\n    cursor: pointer;\n    user-select: none;\n    gap: 0.5rem;\n    transition: background 0.15s;\n}\n\n.club-header:hover {\n    background: var(--gray-200);\n}\n\n.club-header-title {\n    margin: 0;\n    font-size: calc(var(--h1) * 0.75);\n    font-weight: 600;\n    color: var(--gray-800);\n    flex: 1;\n    min-width: 0;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.club-count {\n    font-weight: 400;\n    color: var(--gray-500);\n}\n\n.saved-swimmers-list {\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n    padding: 0.25rem 0;\n}\n\n.saved-swimmer-row {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    padding: 0.3rem 0.5rem 0.3rem 0.75rem;\n    border-bottom: 1px solid var(--gray-100);\n    border-left: 3px solid transparent;\n    cursor: pointer;\n    transition: background 0.1s, border-left-color 0.1s;\n}\n\n.saved-swimmer-row:last-child {\n    border-bottom: none;\n}\n\n.saved-swimmer-row:hover {\n    background: var(--gray-50);\n}\n\n.saved-swimmer-row.selected {\n    background: rgba(37, 99, 235, 0.06);\n    border-left-color: var(--primary);\n}\n\n.saved-swimmer-row-check {\n    width: 1rem;\n    color: var(--primary);\n    font-size: calc(var(--h1) * 0.65);\n    flex-shrink: 0;\n    text-align: center;\n}\n\n.saved-swimmer-row-info {\n    flex: 1;\n    min-width: 0;\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    overflow:hidden;\n}\n\n.saved-swimmer-row-name {\n    font-size: calc(var(--h1) * 0.8);\n    font-weight: 600;\n    color: var(--gray-900);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    flex-shrink: 1;\n    min-width: 0;\n}\n\n.saved-swimmer-row-meta {\n    font-size: calc(var(--h1) * 0.7);\n    color: var(--gray-500);\n    flex-shrink: 0;\n}\n\n.saved-swimmer-row .swimmer-tags {\n    display: flex;\n    gap: 0.25rem;\n    flex-shrink: 0;\n    overflow: hidden;\n    max-width: 40%;\n    margin: 0;\n}\n\n.saved-swimmer-row .swimmer-tags .swimmer-tag-badge {\n    font-size: calc(var(--h1) * 0.6);\n    padding: 0.1rem 0.35rem;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipses;\n    max-width: 8rem;\n}\n\n.saved-swimmer-row-tag-input {\n    flex: 1;\n    min-width: 0;\n}\n\n.saved-swimmer-row-tag-input .group-input {\n    width: 100%;\n}\n\n.saved-swimmer-row-actions {\n    display: flex;\n    align-items: center;\n    gap: 0.25rem;\n    flex-shrink: 0;\n}\n\n.saved-swimmer-row-actions button {\n    padding: 0.2rem 0.5rem;\n    font-size: calc(var(--h1) * 0.65);\n}\n\n.search-results-content {\n    min-width: 0;\n    overflow: hidden;\n}\n\n.search-results-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n    gap: 0.5rem;\n}\n\n.search-carousel {\n    position: relative;\n    display: grid;\n    grid-template-columns: auto 1fr auto;\n    align-items: center;\n    gap: 0.35rem;\n    padding: 1.15rem 0.4rem 1.7rem;\n    border: 1px solid color-mix(in srgb, var(--primary) 20%, var(--gray-200));\n    border-radius: 12px;\n    background:\n        linear-gradient(145deg, color-mix(in srgb, var(--primary) 7%, var(--bg-primary)) 0%, var(--bg-primary) 70%),\n        var(--bg-primary);\n    box-shadow: 0 6px 20px rgba(16, 24, 40, 0.06);\n    overflow: hidden;\n}\n\n.search-carousel-viewport {\n    overflow: hidden;\n    min-width: 0;\n}\n\n.search-carousel-track {\n    display: flex;\n    transition: transform 0.4s ease;\n}\n\n.search-carousel-slide {\n    flex: 0 0 100%;\n    min-width: 0;\n    display: grid;\n    justify-items: center;\n    text-align: center;\n    gap: 0.45rem;\n    padding: 0 0.75rem;\n}\n\n.search-carousel-icon {\n    width: 2.3rem;\n    height: 2.3rem;\n    border-radius: 999px;\n    display: grid;\n    place-items: center;\n    background: color-mix(in srgb, var(--primary) 14%, var(--bg-primary));\n    color: var(--primary);\n    font-size: 0.95rem;\n}\n\n.search-carousel-slide h3 {\n    margin: 0;\n    font-size: calc(var(--h1) * 0.82);\n    line-height: 1.2;\n    letter-spacing: 0.01em;\n    color: var(--gray-900);\n}\n\n.search-carousel-slide p {\n    margin: 0;\n    font-size: calc(var(--h1) * 0.72);\n    color: var(--gray-600);\n    max-width: 34ch;\n}\n\n.search-carousel-examples {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 0.4rem;\n    margin-top: 0.1rem;\n}\n\n.search-carousel-example-chip {\n    padding: 0.3rem 0.8rem;\n    border: 1px solid color-mix(in srgb, var(--primary) 30%, var(--gray-300));\n    border-radius: 999px;\n    background: var(--bg-primary);\n    color: var(--primary);\n    font-size: calc(var(--h1) * 0.68);\n    font-weight: 600;\n    cursor: pointer;\n    transition: background 0.15s ease, color 0.15s ease, transform 0.1s ease;\n}\n\n.search-carousel-example-chip:hover {\n    background: var(--primary);\n    color: #fff;\n    transform: translateY(-1px);\n}\n\n.search-carousel-nav {\n    flex-shrink: 0;\n    width: 2rem;\n    height: 2rem;\n    padding: 0;\n    margin: 0;\n    border-radius: 999px;\n    border: 1px solid color-mix(in srgb, var(--primary) 25%, var(--gray-300));\n    background: var(--bg-primary);\n    color: var(--primary);\n    font-size: 0.7rem;\n    line-height: 1;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease, transform 0.1s ease;\n    z-index: 1;\n}\n\n.search-carousel-nav:hover {\n    background: var(--primary);\n    border-color: var(--primary);\n    color: #fff;\n}\n\n.search-carousel-nav:active {\n    transform: scale(0.92);\n}\n\n.search-carousel-dots {\n    position: absolute;\n    bottom: 0.6rem;\n    left: 0;\n    right: 0;\n    display: flex;\n    justify-content: center;\n    gap: 0.35rem;\n}\n\n.search-carousel-dot {\n    width: 0.4rem;\n    height: 0.4rem;\n    border-radius: 999px;\n    border: none;\n    padding: 0;\n    background: color-mix(in srgb, var(--primary) 25%, var(--gray-300));\n    cursor: pointer;\n    transition: background 0.15s ease, transform 0.15s ease;\n}\n\n.search-carousel-dot.active {\n    background: var(--primary);\n    transform: scale(1.3);\n}\n\n.swimmer-result-compact {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    padding: 0.35rem 0.5rem;\n    border-bottom: 1px solid var(--gray-100);\n    transition: background 0.1s;\n    min-width: 0;\n    overflow: hidden;\n}\n\n.swimmer-result-compact:last-child {\n    border-bottom: none;\n}\n\n.swimmer-result-compact:hover {\n    background: var(--gray-50);\n}\n\n.swimmer-result-compact-name {\n    font-size: calc(var(--h1) * 0.8);\n    font-weight: 600;\n    color: var(--gray-900);\n    flex-shrink: 0;\n}\n\n.swimmer-result-compact-meta {\n    font-size: calc(var(--h1) * 0.7);\n    color: var(--gray-500);\n    flex: 1;\n    min-width: 0;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.swimmer-result-compact button {\n    padding: 0.2rem 0.5rem;\n    font-size: calc(var(--h1) * 0.65);\n    flex-shrink: 0;\n}\n\n.swimmer-result-compact .swimmer-result-save {\n    background: var(--success);\n    color: white;\n    padding: 0.25rem 0.5rem;\n}\n\n.swimmer-result-compact .swimmer-result-save.is-saved {\n    background: transparent;\n    color: var(--success);\n    border: 1px solid var(--success);\n}\n\n.saved-swimmers-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n    gap: 0.5rem;\n    padding: 0.5rem 0.75rem 0.75rem;\n}\n\n.saved-swimmer-card {\n    position: relative;\n    background: linear-gradient(145deg, color-mix(in srgb, var(--primary) 7%, var(--bg-primary)) 0%, var(--bg-primary) 70%);\n    border: 1px solid color-mix(in srgb, var(--primary) 20%, var(--gray-200));\n    border-radius: 10px;\n    padding: 0.45rem 0.65rem 0.45rem 1rem;\n    box-shadow: 0 2px 8px rgba(16, 24, 40, 0.05);\n    overflow: hidden;\n    transition: transform 0.25s ease, border-color 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;\n}\n\n.saved-swimmer-card::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    width: 3px;\n    background: linear-gradient(to bottom, var(--primary), color-mix(in srgb, var(--primary) 55%, white));\n}\n\n.saved-swimmer-card:hover {\n    border-color: var(--primary);\n    box-shadow: 0 4px 14px rgba(16, 24, 40, 0.09);\n}\n\n.saved-swimmer-card.selected {\n    border-color: var(--primary);\n    background: linear-gradient(145deg, color-mix(in srgb, var(--primary) 15%, var(--bg-primary)) 0%, color-mix(in srgb, var(--primary) 5%, var(--bg-primary)) 70%);\n}\n\n.saved-swimmer-card-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 0.25rem;\n}\n\n.saved-swimmer-card-header .selection-badge {\n    position: static;\n    width: 18px;\n    height: 18px;\n    font-size: calc(var(--h1) * 0.55);\n    flex-shrink: 0;\n}\n\n.saved-swimmer-card-header h3 {\n    margin: 0;\n    font-size: calc(var(--h1) * 0.8);\n    color: var(--gray-900);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    min-width: 0;\n}\n\n.saved-swimmer-card-actions {\n    display: flex;\n    align-items: center;\n    flex-shrink: 0;\n    gap: 0;\n}\n\n.saved-swimmer-card-actions .btn-ghost {\n    padding: 0.2rem 0.3rem;\n    font-size: calc(var(--h1) * 0.7);\n    opacity: 0.6;\n    transition: opacity 0.1s;\n}\n\n.saved-swimmer-card:hover .saved-swimmer-card-actions .btn-ghost,\n.saved-swimmer-card-actions .btn-ghost:hover {\n    opacity: 1;\n}\n\n.saved-swimmer-card-meta {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 0.35rem;\n    margin-top: 0.2rem;\n}\n\n.saved-swimmer-card-events {\n    font-size: calc(var(--h1) * 0.65);\n    color: var(--gray-500);\n    white-space: nowrap;\n}\n\n.saved-swimmer-card-tag-input {\n    margin-top: 0.35rem;\n}\n\n.swipe-delete-overlay {\n    position: fixed;\n    inset: 0;\n    background: rgba(0, 0, 0, 0.45);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n}\n\n.swipe-delete-dialog {\n    background: var(--bg-primary);\n    border-radius: 12px;\n    padding: 1.5rem;\n    max-width: 300px;\n    width: 90%;\n    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n}\n\n.swipe-delete-dialog p {\n    margin: 0 0 1.25rem;\n    color: var(--gray-900);\n    font-size: calc(var(--h1) * 0.85);\n    line-height: 1.4;\n}\n\n.swipe-delete-dialog-actions {\n    display: flex;\n    gap: 0.75rem;\n    justify-content: flex-end;\n}\n\n.selection-badge {\n    position: absolute;\n    top: 0.5rem;\n    right: 0.5rem;\n    width: 24px;\n    height: 24px;\n    background: var(--primary);\n    color: white;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: calc(var(--h1) * 0.7);\n    font-weight: bold;\n}\n\n.group-filter {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    margin-bottom: 1rem;\n    padding: 0.75rem;\n    background: var(--gray-50);\n    border-radius: 6px;\n}\n\n.group-filter label {\n    font-size: calc(var(--h1) * 0.7);\n    font-weight: 500;\n    color: var(--gray-700);\n}\n\n.group-filter select {\n    flex: 1;\n    max-width: 300px;\n}\n\n.saved-swimmer-tag-filter {\n    position: relative;\n    flex: 1;\n    max-width: none;\n}\n\n.saved-swimmer-tag-icon {\n    position: absolute;\n    top: 50%;\n    left: 0.875rem;\n    transform: translateY(-50%);\n    width: 1rem;\n    font-size: 0.9rem;\n    color: var(--gray-500);\n    pointer-events: none;\n}\n\n.saved-swimmer-tag-select {\n    -webkit-appearance: none;\n    appearance: none;\n    width: 100%;\n    padding-left: 2.5rem;\n    padding-inline-start: 2.5rem;\n    padding-right: 2.5rem;\n    background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Cpath fill='%236b7280' d='M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z'/%3E%3C/svg%3E\");\n    background-repeat: no-repeat;\n    background-position: right 0.75rem center;\n    background-size: 0.75rem;\n}\n\n.saved-swimmer-tag-select:focus {\n    background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Cpath fill='%236b7280' d='M278.6 105.4c-12.5-12.5-32.8-12.5-45.3 0l-192 192c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L256 173.3l169.4 169.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-192-192z'/%3E%3C/svg%3E\");\n}\n\n.group-filter .saved-swimmer-tag-select {\n    max-width: none;\n}\n\n.saved-swimmer-filter-row .saved-swimmer-search-filter {\n    flex: 1;\n    width: 100%;\n}\n\n.saved-swimmer-filter-row {\n    padding: 0;\n    background: transparent;\n    align-items: stretch;\n    gap: 0.5rem;\n}\n\n.saved-swimmer-filter-row .saved-swimmer-tag-filter,\n.saved-swimmer-filter-row .saved-swimmer-search-filter {\n    flex: 1 1 0;\n    min-width: 0;\n    max-width: none;\n}\n\n.swimmer-tags {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.375rem;\n    margin-bottom: 0.5rem;\n}\n\n.swimmer-tag-badge {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.25rem;\n    padding: 0.2rem 0.5rem;\n    background: var(--primary);\n    color: white;\n    border-radius: 12px;\n    font-size: calc(var(--h1) * 0.6);\n    font-weight: 500;\n    opacity: 0.8;\n}\n\n.swimmer-tag-badge.inactive {\n    opacity: 0.45;\n}\n\n.swimmer-tag-remove {\n    background: none;\n    border: none;\n    color: white;\n    cursor: pointer;\n    padding: 0;\n    line-height: 1;\n    font-size: calc(var(--h1) * 0.52);\n    opacity: 0.7;\n    display: flex;\n    align-items: center;\n}\n\n.swimmer-tag-remove:hover {\n    opacity: 1;\n}\n\n.group-button {\n    background-color: var(--primary-light) !important;\n    color: var(--text-primary) !important;\n    flex: 1;\n    padding: 0.5rem 0.75rem;\n    font-size: calc(var(--h1) * 0.65);\n    background: var(--gray-100);\n    border: 1px solid var(--gray-300);\n    border-radius: 4px;\n    cursor: pointer;\n    transition: all 0.15s ease;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.group-button:hover {\n    background: var(--gray-200);\n    border-color: var(--primary);\n}\n\n.group-edit-container {\n    flex: 1;\n    display: flex;\n    min-width: 0;\n}\n\n.group-input {\n    flex: 1;\n    padding: 0.5rem;\n    font-size: calc(var(--h1) * 0.65);\n    border: 2px solid var(--primary);\n    border-radius: 4px;\n    min-width: 0;\n    width: 0;\n    color: var(--gray-900);\n}\n\n.group-input:focus {\n    outline: none;\n    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);\n}\n\n.saved-swimmer-search-filter {\n    display: block;\n    position: relative;\n    width: 100%;\n}\n\n.saved-swimmer-search-icon {\n    position: absolute;\n    top: 50%;\n    left: 0.875rem;\n    transform: translateY(-50%);\n    width: 1rem;\n    font-size: 0.9rem;\n    color: var(--gray-500);\n    pointer-events: none;\n}\n\n.saved-swimmer-search-input {\n    width: 100%;\n    min-width: 100%;\n    padding-left: 2.85rem !important;\n    padding-right: 2rem !important;\n    padding-inline-start: 2.85rem !important;\n    padding-inline-end: 2rem !important;\n}\n\n.saved-swimmer-search-clear,\n.search-filter-clear {\n    position: absolute;\n    top: 50%;\n    right: 0.5rem;\n    transform: translateY(-50%);\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 1.5rem;\n    height: 1.5rem;\n    border: none;\n    border-radius: 999px;\n    background: transparent;\n    color: var(--gray-500);\n    cursor: pointer;\n    transition: color 0.15s ease, background-color 0.15s ease;\n}\n\n.saved-swimmer-search-clear:hover,\n.search-filter-clear:hover {\n    color: var(--gray-700);\n    background: var(--gray-100);\n}\n\n.saved-swimmer-search-clear:active,\n.search-filter-clear:active {\n    transform: translateY(-50%) scale(0.98);\n}\n\n.comparison-section {\n    margin-bottom: 2rem;\n}\n\n.swimmer-comparison-names {\n    display: flex;\n    gap: 1rem;\n    margin-bottom: 1.5rem;\n    flex-wrap: wrap;\n}\n\n.comparison-swimmer-tag {\n    flex: 1;\n    min-width: 200px;\n    padding: 1rem;\n    background: var(--gray-50);\n    border-radius: 6px;\n    border-left: 4px solid var(--primary);\n}\n\n.comparison-swimmer-tag strong {\n    display: block;\n    font-size: calc(var(--h1) * 0.8);\n    color: var(--gray-900);\n    margin-bottom: 0.25rem;\n}\n\n.comparison-swimmer-tag span {\n    font-size: calc(var(--h1) * 0.7);\n    color: var(--gray-600);\n}\n\n.theme-selector {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    padding: 0.5rem 0;\n}\n\n.theme-selector label {\n    font-size: calc(var(--h1) * 0.7);\n    font-weight: 500;\n    color: var(--gray-700);\n}\n\n.theme-options {\n    display: flex;\n    gap: 0.5rem;\n}\n\n.theme-option {\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    border: 2px solid transparent;\n    cursor: pointer;\n    transition: all 0.15s ease;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: white;\n    font-weight: bold;\n    font-size: calc(var(--h1) * 0.7);\n}\n\n.theme-option:hover {\n    transform: scale(1.1);\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n}\n\n.theme-option.active {\n    border-color: var(--gray-900);\n    box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.1);\n}\n\n.loading {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(17, 24, 39, 0.5);\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n}\n\n.spinner {\n    border: 4px solid var(--gray-200);\n    border-top: 4px solid var(--primary);\n    border-radius: 50%;\n    width: 50px;\n    height: 50px;\n    animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n    0% {\n        transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n@keyframes swimAcross {\n    0% { left: -2.5rem; }\n    100% { left: 100%; }\n}\n\n@keyframes rankingsSlide {\n    0% { transform: translateX(-120%); }\n    100% { transform: translateX(500%); }\n}\n\n.loading p {\n    color: white;\n    margin-top: 1rem;\n    font-size: calc(var(--h1) * 0.8);\n    font-weight: 500;\n}\n\n.toast {\n    position: fixed;\n    bottom: max(1.5rem, calc(env(safe-area-inset-bottom) + 0.5rem));\n    right: max(1.5rem, calc(env(safe-area-inset-right) + 0.5rem));\n    max-width: 400px;\n    padding: 1rem 1.25rem;\n    background: var(--gray-800);\n    color: white;\n    border-radius: 6px;\n    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);\n    opacity: 0;\n    transform: translateY(1rem);\n    transition: all 0.2s ease;\n    z-index: 1001;\n    font-size: calc(var(--h1) * 0.75);\n}\n\n.toast.show {\n    opacity: 1;\n    transform: translateY(0);\n}\n\n.toast.success {\n    background: var(--success);\n}\n\n.toast.error {\n    background: var(--danger);\n}\n\n.ptr-indicator {\n    position: fixed;\n    top: -56px;\n    left: 0;\n    right: 0;\n    height: 56px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 200;\n    pointer-events: none;\n    will-change: transform, opacity;\n}\n\n.ptr-icon {\n    width: 36px;\n    height: 36px;\n    border-radius: 50%;\n    background: var(--bg-primary);\n    border: 1px solid var(--gray-200);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--gray-700);\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);\n    transition: transform 0.15s ease, color 0.15s ease;\n}\n\n.ptr-icon.triggered {\n    color: var(--primary);\n    transform: rotate(180deg);\n}\n\n.ptr-icon.refreshing {\n    color: var(--primary);\n}\n\n.install-prompt {\n    position: fixed;\n    bottom: max(1rem, calc(env(safe-area-inset-bottom) + 0.5rem));\n    left: 50%;\n    transform: translateX(-50%);\n    max-width: min(500px, calc(100% - 2rem));\n    width: max-content;\n    padding: 0.75rem 0.85rem 0.75rem 1rem;\n    background: var(--primary);\n    color: #ffffff;\n    border-radius: 10px;\n    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.25);\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    z-index: 1000;\n    font-size: 0.95rem;\n}\n\n.install-prompt-text {\n    flex: 1;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.install-prompt-btn {\n    background: #ffffff;\n    color: var(--primary);\n    border: none;\n    padding: 0.45rem 0.95rem;\n    border-radius: 6px;\n    font-weight: 600;\n    font-size: 0.9rem;\n    cursor: pointer;\n    white-space: nowrap;\n}\n\n.install-prompt-btn:hover {\n    filter: brightness(0.95);\n}\n\n.install-prompt-btn-block {\n    display: block;\n    width: 100%;\n    margin-top: 0.5rem;\n    padding: 0.6rem 1rem;\n    background: var(--primary);\n    color: #ffffff;\n}\n\n.install-prompt-close {\n    background: transparent;\n    color: #ffffff;\n    border: none;\n    font-size: 1.5rem;\n    line-height: 1;\n    cursor: pointer;\n    padding: 0 0.25rem;\n    opacity: 0.8;\n}\n\n.install-prompt-close:hover {\n    opacity: 1;\n}\n\n.install-prompt-modal {\n    position: fixed;\n    inset: 0;\n    background: rgba(0, 0, 0, 0.55);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1002;\n    padding: 1rem;\n}\n\n.install-prompt-modal-content {\n    background: var(--bg-primary);\n    color: var(--text-primary);\n    padding: 1.5rem;\n    border-radius: 12px;\n    max-width: 420px;\n    width: 100%;\n    box-shadow: 0 20px 40px -10px rgba(0, 0, 0, 0.35);\n}\n\n.install-prompt-modal-content h3 {\n    margin: 0 0 0.75rem;\n    color: var(--primary);\n}\n\n.install-prompt-modal-content ol {\n    margin: 0;\n    padding-left: 1.25rem;\n    line-height: 1.7;\n    color: var(--text-primary);\n}\n\n.bottom-nav {\n    display: none;\n}\n\n.header-theme {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.5rem;\n}\n\n.empty-state {\n    text-align: center;\n    padding: 3rem 1.5rem;\n    color: var(--gray-600);\n    background: var(--gray-50);\n    border-radius: 6px;\n    border: 1px solid var(--gray-200);\n}\n\n.empty-state p {\n    font-size: calc(var(--h1) * 0.75);\n    margin: 0;\n}\n\n::-webkit-scrollbar {\n    width: 8px;\n    height: 8px;\n}\n\n::-webkit-scrollbar-track {\n    background: var(--gray-100);\n}\n\n::-webkit-scrollbar-thumb {\n    background: var(--gray-300);\n    border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n    background: var(--gray-400);\n}\n\n.auth-service-banner {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    padding: 0.6rem 1rem;\n    margin-bottom: 1rem;\n    background: rgba(59, 130, 246, 0.08);\n    border: 1px solid rgba(37, 99, 235, 0.25);\n    border-radius: 8px;\n    font-size: 0.9rem;\n    color: var(--gray-700, #374151);\n    flex-wrap: wrap;\n}\n\n.auth-service-banner-text {\n    flex: 1 1 auto;\n    min-width: 0;\n    line-height: 1.4;\n}\n\n.auth-service-banner-text strong {\n    color: var(--primary);\n}\n\n.auth-service-banner-dismiss {\n    width: 28px;\n    height: 28px;\n    padding: 0;\n    border: none;\n    background: transparent;\n    color: var(--gray-500, #6b7280);\n    font-size: 1.4rem;\n    line-height: 1;\n    cursor: pointer;\n    border-radius: 50%;\n    flex-shrink: 0;\n    transition: background 0.15s ease;\n}\n\n.auth-service-banner-dismiss:hover {\n    background: rgba(0, 0, 0, 0.06);\n}\n\n.guest-banner {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    padding: 0.6rem 1rem;\n    margin-bottom: 1rem;\n    background: rgba(59, 130, 246, 0.08);\n    border: 1px solid rgba(37, 99, 235, 0.25);\n    border-radius: 8px;\n    font-size: 0.9rem;\n    color: var(--gray-700, #374151);\n    flex-wrap: wrap;\n}\n\n.guest-banner-text {\n    flex: 1 1 auto;\n    min-width: 0;\n    line-height: 1.4;\n}\n\n.guest-banner-text strong {\n    color: var(--primary);\n}\n\n.guest-banner-signin {\n    padding: 0.4rem 0.9rem;\n    border-radius: 999px;\n    border: 1px solid var(--primary);\n    background: var(--primary);\n    color: #fff;\n    font-weight: 600;\n    cursor: pointer;\n    flex-shrink: 0;\n    transition: background 0.15s ease, transform 0.15s ease;\n}\n\n.guest-banner-signin:hover {\n    background: var(--primary-dark, #2563eb);\n}\n\n.guest-banner-signin:active {\n    transform: translateY(1px);\n}\n\n.guest-banner-dismiss {\n    width: 28px;\n    height: 28px;\n    padding: 0;\n    border: none;\n    background: transparent;\n    color: var(--gray-500, #6b7280);\n    font-size: 1.4rem;\n    line-height: 1;\n    cursor: pointer;\n    border-radius: 50%;\n    flex-shrink: 0;\n    transition: background 0.15s ease;\n}\n\n.guest-banner-dismiss:hover {\n    background: rgba(0, 0, 0, 0.06);\n}\n\n.notification-banner {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    padding: 0.6rem 1rem;\n    margin-bottom: 1rem;\n    background: rgba(34, 197, 94, 0.08);\n    border: 1px solid rgba(34, 197, 94, 0.25);\n    border-radius: 8px;\n    font-size: 0.9rem;\n    color: var(--gray-700, #374151);\n    flex-wrap: wrap;\n}\n\n.notification-banner-text {\n    flex: 1 1 auto;\n    min-width: 0;\n    line-height: 1.4;\n}\n\n.notification-banner-text strong {\n    color: var(--success, #22c55e);\n}\n\n.notification-banner-enable {\n    padding: 0.4rem 0.9rem;\n    border-radius: 999px;\n    border: 1px solid var(--success, #22c55e);\n    background: var(--success, #22c55e);\n    color: #fff;\n    font-weight: 600;\n    cursor: pointer;\n    flex-shrink: 0;\n    transition: background 0.15s ease, transform 0.15s ease;\n}\n\n.notification-banner-enable:hover {\n    background: #16a34a;\n}\n\n.notification-banner-enable:active {\n    transform: translateY(1px);\n}\n\n.notification-banner-dismiss {\n    width: 28px;\n    height: 28px;\n    padding: 0;\n    border: none;\n    background: transparent;\n    color: var(--gray-500, #6b7280);\n    font-size: 1.4rem;\n    line-height: 1;\n    cursor: pointer;\n    border-radius: 50%;\n    flex-shrink: 0;\n    transition: background 0.15s ease;\n}\n\n.notification-banner-dismiss:hover {\n    background: rgba(0, 0, 0, 0.06);\n}\n\n.notification-banner-inbox {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.5rem;\n    padding: 0.4rem 0.9rem;\n    border: 1px solid var(--border-color);\n    border-radius: 999px;\n    background: var(--surface-secondary);\n    color: var(--text-primary);\n    font-size: 0.875rem;\n    cursor: pointer;\n    margin-bottom: 0.75rem;\n}\n\n.notification-banner-inbox:hover {\n    background: var(--gray-100);\n}\n\n.notification-banner-badge {\n    position: absolute;\n    top: -4px;\n    right: -6px;\n    min-width: 16px;\n    height: 16px;\n    padding: 0 3px;\n    background: var(--primary);\n    color: #fff;\n    border-radius: 8px;\n    font-size: 0.6rem;\n    font-weight: 700;\n    line-height: 16px;\n    text-align: center;\n    pointer-events: none;\n}\n\n.offline-banner {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    padding: 0.6rem 1rem;\n    margin-bottom: 1rem;\n    background: rgba(245, 158, 11, 0.12);\n    border: 1px solid rgba(217, 119, 6, 0.35);\n    border-radius: 8px;\n    font-size: 0.9rem;\n    color: var(--gray-700, #374151);\n}\n\n.offline-banner-text {\n    flex: 1 1 auto;\n    line-height: 1.4;\n}\n\n.update-banner {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    padding: 0.6rem 1rem;\n    margin-bottom: 1rem;\n    background: rgba(59, 130, 246, 0.35);\n    border: 1px solid rgba(59, 130, 246, 0.35);\n    border-radius: 0.9rem;\n    font-size: 0.9rem;\n    color: var(--gray-700, #374151);\n}\n\n.update-banner-text {\n    flex: 1 1 auto;\n    line-height: 1.4;\n}\n\n.update-banner-btn {\n    flex-shrink: 0;\n    padding: 0.3rem 0.75rem;\n    background: var(--primary, #3b82f6);\n    color: #fff;\n    border: none;\n    border-radius: 6px;\n    font-size: 0.85rem;\n    cursor: pointer;\n    font-weight: 500;\n}\n\n.update-banner-btn:hover {\n    opacity: 0.88;\n}\n\n.update-banner-spinner {\n    width: 1rem;\n    height: 1rem;\n    border: 2px solid rgba(255, 255, 255, 0.45);\n    border-top-color: rgba(255, 255, 255, 0.95);\n    border-radius: 50%;\n    animation: spin 0.8s linear infinite;\n}\n\n.update-banner-close {\n    flex-shrink: 0;\n    width: 1.5rem;\n    height: 1.5rem;\n    padding: 0;\n    background: transparent;\n    border: none;\n    font-size: 1.25rem;\n    color: var(--gray-600, #4b5563);\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    line-height: 1;\n}\n\n.update-banner-close:hover {\n    color: var(--gray-900, #111827);\n}\n\n.notification-delete-btn {\n    display: none;\n    color: var(--text-secondary);\n    padding: 0.25rem 0.4rem;\n    font-size: 0.8rem;\n    line-height: 1;\n}\n\n.notification-delete-btn:hover {\n    color: var(--danger);\n}\n\n@media (pointer: fine) {\n    .notification-delete-btn {\n        display: flex;\n        align-items: center;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
